/// Auto-generated. Modifications will be overwritten.
/// Generated from core/overriden-document-schemas/DocumentsModel.yaml
/** Metadata for the document */
export class Metadata {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return Metadata.DOCUMENT_TYPE;
    }
    /** Issuing country of the document */
    get country() {
        return this.document.fields.find((f) => f.type.name === 'Country');
    }
    /** Document side, either FRONT or BACK. */
    get documentSide() {
        return this.document.fields.find((f) => f.type.name === 'DocumentSide');
    }
    /** Either SINGLE_SIDED or TWO_SIDED. */
    get printingFormat() {
        return this.document.fields.find((f) => f.type.name === 'PrintingFormat');
    }
    /** Tags for the document */
    get tagss() {
        return this.document.fields.filter((f) => f.type.name === 'Tags');
    }
}
Metadata.DOCUMENT_TYPE = 'Metadata';
Metadata.COUNTRY_FIELD_NAME = 'Country';
Metadata.COUNTRY_FIELD_NAME_NORMALIZED = 'Metadata.Country';
Metadata.DOCUMENT_SIDE_FIELD_NAME = 'DocumentSide';
Metadata.DOCUMENT_SIDE_FIELD_NAME_NORMALIZED = 'Metadata.DocumentSide';
Metadata.PRINTING_FORMAT_FIELD_NAME = 'PrintingFormat';
Metadata.PRINTING_FORMAT_FIELD_NAME_NORMALIZED = 'Metadata.PrintingFormat';
Metadata.TAGS_FIELD_NAME = 'Tags';
Metadata.TAGS_FIELD_NAME_NORMALIZED = 'Metadata.Tags';
/** MRZ part of the document */
export class MRZ {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return MRZ.DOCUMENT_TYPE;
    }
    /** Birth date */
    get birthDate() {
        return this.document.fields.find((f) => f.type.name === 'BirthDate');
    }
    /** Check digit birth date */
    get checkDigitBirthDate() {
        return this.document.fields.find((f) => f.type.name === 'CheckDigitBirthDate');
    }
    /** Check digit document number */
    get checkDigitDocumentNumber() {
        return this.document.fields.find((f) => f.type.name === 'CheckDigitDocumentNumber');
    }
    /** Check digit expiry date */
    get checkDigitExpiryDate() {
        return this.document.fields.find((f) => f.type.name === 'CheckDigitExpiryDate');
    }
    /** Check  digit general */
    get checkDigitGeneral() {
        return this.document.fields.find((f) => f.type.name === 'CheckDigitGeneral');
    }
    /** Check digit personal number */
    get checkDigitPersonalNumber() {
        return this.document.fields.find((f) => f.type.name === 'CheckDigitPersonalNumber');
    }
    /** Date of issuance */
    get dateOfIssuance() {
        return this.document.fields.find((f) => f.type.name === 'DateOfIssuance');
    }
    /** Document number */
    get documentNumber() {
        return this.document.fields.find((f) => f.type.name === 'DocumentNumber');
    }
    /** Document type from the DocumentType enum */
    get documentType() {
        return this.document.fields.find((f) => f.type.name === 'DocumentType');
    }
    /** Document type code */
    get documentTypeCode() {
        return this.document.fields.find((f) => f.type.name === 'DocumentTypeCode');
    }
    /** Expiry date */
    get expiryDate() {
        return this.document.fields.find((f) => f.type.name === 'ExpiryDate');
    }
    /** Gender */
    get gender() {
        return this.document.fields.find((f) => f.type.name === 'Gender');
    }
    /** Given names */
    get givenNames() {
        return this.document.fields.find((f) => f.type.name === 'GivenNames');
    }
    /** Issuing authority */
    get issuingAuthority() {
        return this.document.fields.find((f) => f.type.name === 'IssuingAuthority');
    }
    /** Language code */
    get languageCode() {
        return this.document.fields.find((f) => f.type.name === 'LanguageCode');
    }
    /** Nationality */
    get nationality() {
        return this.document.fields.find((f) => f.type.name === 'Nationality');
    }
    /** Office of issuance */
    get officeOfIssuance() {
        return this.document.fields.find((f) => f.type.name === 'OfficeOfIssuance');
    }
    /** TD1 Optional field (line 2) */
    get optional1() {
        return this.document.fields.find((f) => f.type.name === 'Optional1');
    }
    /** TD1 Optional field (line 3) */
    get optional2() {
        return this.document.fields.find((f) => f.type.name === 'Optional2');
    }
    /** PIN code */
    get pinCode() {
        return this.document.fields.find((f) => f.type.name === 'PINCode');
    }
    /** Personal number */
    get personalNumber() {
        return this.document.fields.find((f) => f.type.name === 'PersonalNumber');
    }
    /** Surname */
    get surname() {
        return this.document.fields.find((f) => f.type.name === 'Surname');
    }
    /** Travel document type */
    get travelDocType() {
        return this.document.fields.find((f) => f.type.name === 'TravelDocType');
    }
    /** Travel document type variant */
    get travelDocTypeVariant() {
        return this.document.fields.find((f) => f.type.name === 'TravelDocTypeVariant');
    }
    /** Unknown */
    get unknown() {
        return this.document.fields.find((f) => f.type.name === 'Unknown');
    }
    /** Version number */
    get versionNumber() {
        return this.document.fields.find((f) => f.type.name === 'VersionNumber');
    }
    /** MRV-A/MRV-B (Travel Visa) Optional field */
    get visaOptional() {
        return this.document.fields.find((f) => f.type.name === 'VisaOptional');
    }
}
MRZ.DOCUMENT_TYPE = 'MRZ';
MRZ.BIRTH_DATE_FIELD_NAME = 'BirthDate';
MRZ.BIRTH_DATE_FIELD_NAME_NORMALIZED = 'MRZ.BirthDate';
MRZ.CHECK_DIGIT_BIRTH_DATE_FIELD_NAME = 'CheckDigitBirthDate';
MRZ.CHECK_DIGIT_BIRTH_DATE_FIELD_NAME_NORMALIZED = 'MRZ.CheckDigitBirthDate';
MRZ.CHECK_DIGIT_DOCUMENT_NUMBER_FIELD_NAME = 'CheckDigitDocumentNumber';
MRZ.CHECK_DIGIT_DOCUMENT_NUMBER_FIELD_NAME_NORMALIZED = 'MRZ.CheckDigitDocumentNumber';
MRZ.CHECK_DIGIT_EXPIRY_DATE_FIELD_NAME = 'CheckDigitExpiryDate';
MRZ.CHECK_DIGIT_EXPIRY_DATE_FIELD_NAME_NORMALIZED = 'MRZ.CheckDigitExpiryDate';
MRZ.CHECK_DIGIT_GENERAL_FIELD_NAME = 'CheckDigitGeneral';
MRZ.CHECK_DIGIT_GENERAL_FIELD_NAME_NORMALIZED = 'MRZ.CheckDigitGeneral';
MRZ.CHECK_DIGIT_PERSONAL_NUMBER_FIELD_NAME = 'CheckDigitPersonalNumber';
MRZ.CHECK_DIGIT_PERSONAL_NUMBER_FIELD_NAME_NORMALIZED = 'MRZ.CheckDigitPersonalNumber';
MRZ.DATE_OF_ISSUANCE_FIELD_NAME = 'DateOfIssuance';
MRZ.DATE_OF_ISSUANCE_FIELD_NAME_NORMALIZED = 'MRZ.DateOfIssuance';
MRZ.DOCUMENT_NUMBER_FIELD_NAME = 'DocumentNumber';
MRZ.DOCUMENT_NUMBER_FIELD_NAME_NORMALIZED = 'MRZ.DocumentNumber';
MRZ.DOCUMENT_TYPE_FIELD_NAME = 'DocumentType';
MRZ.DOCUMENT_TYPE_FIELD_NAME_NORMALIZED = 'MRZ.DocumentType';
MRZ.DOCUMENT_TYPE_CODE_FIELD_NAME = 'DocumentTypeCode';
MRZ.DOCUMENT_TYPE_CODE_FIELD_NAME_NORMALIZED = 'MRZ.DocumentTypeCode';
MRZ.EXPIRY_DATE_FIELD_NAME = 'ExpiryDate';
MRZ.EXPIRY_DATE_FIELD_NAME_NORMALIZED = 'MRZ.ExpiryDate';
MRZ.GENDER_FIELD_NAME = 'Gender';
MRZ.GENDER_FIELD_NAME_NORMALIZED = 'MRZ.Gender';
MRZ.GIVEN_NAMES_FIELD_NAME = 'GivenNames';
MRZ.GIVEN_NAMES_FIELD_NAME_NORMALIZED = 'MRZ.GivenNames';
MRZ.ISSUING_AUTHORITY_FIELD_NAME = 'IssuingAuthority';
MRZ.ISSUING_AUTHORITY_FIELD_NAME_NORMALIZED = 'MRZ.IssuingAuthority';
MRZ.LANGUAGE_CODE_FIELD_NAME = 'LanguageCode';
MRZ.LANGUAGE_CODE_FIELD_NAME_NORMALIZED = 'MRZ.LanguageCode';
MRZ.NATIONALITY_FIELD_NAME = 'Nationality';
MRZ.NATIONALITY_FIELD_NAME_NORMALIZED = 'MRZ.Nationality';
MRZ.OFFICE_OF_ISSUANCE_FIELD_NAME = 'OfficeOfIssuance';
MRZ.OFFICE_OF_ISSUANCE_FIELD_NAME_NORMALIZED = 'MRZ.OfficeOfIssuance';
MRZ.OPTIONAL_1_FIELD_NAME = 'Optional1';
MRZ.OPTIONAL_1_FIELD_NAME_NORMALIZED = 'MRZ.Optional1';
MRZ.OPTIONAL_2_FIELD_NAME = 'Optional2';
MRZ.OPTIONAL_2_FIELD_NAME_NORMALIZED = 'MRZ.Optional2';
MRZ.PIN_CODE_FIELD_NAME = 'PINCode';
MRZ.PIN_CODE_FIELD_NAME_NORMALIZED = 'MRZ.PINCode';
MRZ.PERSONAL_NUMBER_FIELD_NAME = 'PersonalNumber';
MRZ.PERSONAL_NUMBER_FIELD_NAME_NORMALIZED = 'MRZ.PersonalNumber';
MRZ.SURNAME_FIELD_NAME = 'Surname';
MRZ.SURNAME_FIELD_NAME_NORMALIZED = 'MRZ.Surname';
MRZ.TRAVEL_DOC_TYPE_FIELD_NAME = 'TravelDocType';
MRZ.TRAVEL_DOC_TYPE_FIELD_NAME_NORMALIZED = 'MRZ.TravelDocType';
MRZ.TRAVEL_DOC_TYPE_VARIANT_FIELD_NAME = 'TravelDocTypeVariant';
MRZ.TRAVEL_DOC_TYPE_VARIANT_FIELD_NAME_NORMALIZED = 'MRZ.TravelDocTypeVariant';
MRZ.UNKNOWN_FIELD_NAME = 'Unknown';
MRZ.UNKNOWN_FIELD_NAME_NORMALIZED = 'MRZ.Unknown';
MRZ.VERSION_NUMBER_FIELD_NAME = 'VersionNumber';
MRZ.VERSION_NUMBER_FIELD_NAME_NORMALIZED = 'MRZ.VersionNumber';
MRZ.VISA_OPTIONAL_FIELD_NAME = 'VisaOptional';
MRZ.VISA_OPTIONAL_FIELD_NAME_NORMALIZED = 'MRZ.VisaOptional';
/** Parsed German Address part of the document */
export class ParsedDeAddress {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return ParsedDeAddress.DOCUMENT_TYPE;
    }
    /** District or city area corresponding to postal code */
    get district() {
        return this.document.fields.find((f) => f.type.name === 'District');
    }
    /** Additional information to district or city area (e.g. Ortsteil, Stadtteil) */
    get districtAddition() {
        return this.document.fields.find((f) => f.type.name === 'DistrictAddition');
    }
    /** House number */
    get houseNumber() {
        return this.document.fields.find((f) => f.type.name === 'HouseNumber');
    }
    /** postal code */
    get postalCode() {
        return this.document.fields.find((f) => f.type.name === 'PostalCode');
    }
    /** Street name */
    get streetName() {
        return this.document.fields.find((f) => f.type.name === 'StreetName');
    }
}
ParsedDeAddress.DOCUMENT_TYPE = 'ParsedDeAddress';
ParsedDeAddress.DISTRICT_FIELD_NAME = 'District';
ParsedDeAddress.DISTRICT_FIELD_NAME_NORMALIZED = 'ParsedDeAddress.District';
ParsedDeAddress.DISTRICT_ADDITION_FIELD_NAME = 'DistrictAddition';
ParsedDeAddress.DISTRICT_ADDITION_FIELD_NAME_NORMALIZED = 'ParsedDeAddress.DistrictAddition';
ParsedDeAddress.HOUSE_NUMBER_FIELD_NAME = 'HouseNumber';
ParsedDeAddress.HOUSE_NUMBER_FIELD_NAME_NORMALIZED = 'ParsedDeAddress.HouseNumber';
ParsedDeAddress.POSTAL_CODE_FIELD_NAME = 'PostalCode';
ParsedDeAddress.POSTAL_CODE_FIELD_NAME_NORMALIZED = 'ParsedDeAddress.PostalCode';
ParsedDeAddress.STREET_NAME_FIELD_NAME = 'StreetName';
ParsedDeAddress.STREET_NAME_FIELD_NAME_NORMALIZED = 'ParsedDeAddress.StreetName';
/** German ID card, front side */
export class DeIdCardFront {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return DeIdCardFront.DOCUMENT_TYPE;
    }
    /** Birth date */
    get birthDate() {
        return this.document.fields.find((f) => f.type.name === 'BirthDate');
    }
    /** Birthplace */
    get birthplace() {
        return this.document.fields.find((f) => f.type.name === 'Birthplace');
    }
    /** Six digit card access number */
    get cardAccessNumber() {
        return this.document.fields.find((f) => f.type.name === 'CardAccessNumber');
    }
    /** Expiry date */
    get expiryDate() {
        return this.document.fields.find((f) => f.type.name === 'ExpiryDate');
    }
    /** Given names */
    get givenNames() {
        return this.document.fields.find((f) => f.type.name === 'GivenNames');
    }
    /** Document ID number (in the top-right corner) */
    get id() {
        return this.document.fields.find((f) => f.type.name === 'ID');
    }
    /** Maiden name */
    get maidenName() {
        return this.document.fields.find((f) => f.type.name === 'MaidenName');
    }
    /** Nationality */
    get nationality() {
        return this.document.fields.find((f) => f.type.name === 'Nationality');
    }
    /** Photo image */
    get photo() {
        return this.document.fields.find((f) => f.type.name === 'Photo');
    }
    /** Series of the document. The format is YYMM. */
    get series() {
        return this.document.fields.find((f) => f.type.name === 'Series');
    }
    /** Signature image */
    get signature() {
        return this.document.fields.find((f) => f.type.name === 'Signature');
    }
    /** Surname */
    get surname() {
        return this.document.fields.find((f) => f.type.name === 'Surname');
    }
    /** The child document of type "Metadata". */
    get metadata() {
        const child = this.document.children.find((c) => c.type.name === 'Metadata');
        return new Metadata(child);
    }
}
DeIdCardFront.DOCUMENT_TYPE = 'DeIdCardFront';
DeIdCardFront.BIRTH_DATE_FIELD_NAME = 'BirthDate';
DeIdCardFront.BIRTH_DATE_FIELD_NAME_NORMALIZED = 'DeIdCardFront.BirthDate';
DeIdCardFront.BIRTHPLACE_FIELD_NAME = 'Birthplace';
DeIdCardFront.BIRTHPLACE_FIELD_NAME_NORMALIZED = 'DeIdCardFront.Birthplace';
DeIdCardFront.CARD_ACCESS_NUMBER_FIELD_NAME = 'CardAccessNumber';
DeIdCardFront.CARD_ACCESS_NUMBER_FIELD_NAME_NORMALIZED = 'DeIdCardFront.CardAccessNumber';
DeIdCardFront.EXPIRY_DATE_FIELD_NAME = 'ExpiryDate';
DeIdCardFront.EXPIRY_DATE_FIELD_NAME_NORMALIZED = 'DeIdCardFront.ExpiryDate';
DeIdCardFront.GIVEN_NAMES_FIELD_NAME = 'GivenNames';
DeIdCardFront.GIVEN_NAMES_FIELD_NAME_NORMALIZED = 'DeIdCardFront.GivenNames';
DeIdCardFront.ID_FIELD_NAME = 'ID';
DeIdCardFront.ID_FIELD_NAME_NORMALIZED = 'DeIdCardFront.ID';
DeIdCardFront.MAIDEN_NAME_FIELD_NAME = 'MaidenName';
DeIdCardFront.MAIDEN_NAME_FIELD_NAME_NORMALIZED = 'DeIdCardFront.MaidenName';
DeIdCardFront.NATIONALITY_FIELD_NAME = 'Nationality';
DeIdCardFront.NATIONALITY_FIELD_NAME_NORMALIZED = 'DeIdCardFront.Nationality';
DeIdCardFront.PHOTO_FIELD_NAME = 'Photo';
DeIdCardFront.PHOTO_FIELD_NAME_NORMALIZED = 'DeIdCardFront.Photo';
DeIdCardFront.SERIES_FIELD_NAME = 'Series';
DeIdCardFront.SERIES_FIELD_NAME_NORMALIZED = 'DeIdCardFront.Series';
DeIdCardFront.SIGNATURE_FIELD_NAME = 'Signature';
DeIdCardFront.SIGNATURE_FIELD_NAME_NORMALIZED = 'DeIdCardFront.Signature';
DeIdCardFront.SURNAME_FIELD_NAME = 'Surname';
DeIdCardFront.SURNAME_FIELD_NAME_NORMALIZED = 'DeIdCardFront.Surname';
/** German ID card, back side */
export class DeIdCardBack {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return DeIdCardBack.DOCUMENT_TYPE;
    }
    /** Raw Address text value */
    get address() {
        return this.document.fields.find((f) => f.type.name === 'Address');
    }
    /** Eye color */
    get eyeColor() {
        return this.document.fields.find((f) => f.type.name === 'EyeColor');
    }
    /** Height */
    get height() {
        return this.document.fields.find((f) => f.type.name === 'Height');
    }
    /** Issue date */
    get issueDate() {
        return this.document.fields.find((f) => f.type.name === 'IssueDate');
    }
    /** Issuing authority */
    get issuingAuthority() {
        return this.document.fields.find((f) => f.type.name === 'IssuingAuthority');
    }
    /** Pseudonym */
    get pseudonym() {
        return this.document.fields.find((f) => f.type.name === 'Pseudonym');
    }
    /** Raw MRZ text value */
    get rawMRZ() {
        return this.document.fields.find((f) => f.type.name === 'RawMRZ');
    }
    /** Series of the document. The format is YYMM. */
    get series() {
        return this.document.fields.find((f) => f.type.name === 'Series');
    }
    /** The child document of type "MRZ". */
    get mrz() {
        const child = this.document.children.find((c) => c.type.name === 'MRZ');
        return new MRZ(child);
    }
    /** The child document of type "ParsedDeAddress". */
    get parsedDeAddress() {
        const child = this.document.children.find((c) => c.type.name === 'ParsedDeAddress');
        return new ParsedDeAddress(child);
    }
    /** The child document of type "Metadata". */
    get metadata() {
        const child = this.document.children.find((c) => c.type.name === 'Metadata');
        return new Metadata(child);
    }
}
DeIdCardBack.DOCUMENT_TYPE = 'DeIdCardBack';
DeIdCardBack.ADDRESS_FIELD_NAME = 'Address';
DeIdCardBack.ADDRESS_FIELD_NAME_NORMALIZED = 'DeIdCardBack.Address';
DeIdCardBack.EYE_COLOR_FIELD_NAME = 'EyeColor';
DeIdCardBack.EYE_COLOR_FIELD_NAME_NORMALIZED = 'DeIdCardBack.EyeColor';
DeIdCardBack.HEIGHT_FIELD_NAME = 'Height';
DeIdCardBack.HEIGHT_FIELD_NAME_NORMALIZED = 'DeIdCardBack.Height';
DeIdCardBack.ISSUE_DATE_FIELD_NAME = 'IssueDate';
DeIdCardBack.ISSUE_DATE_FIELD_NAME_NORMALIZED = 'DeIdCardBack.IssueDate';
DeIdCardBack.ISSUING_AUTHORITY_FIELD_NAME = 'IssuingAuthority';
DeIdCardBack.ISSUING_AUTHORITY_FIELD_NAME_NORMALIZED = 'DeIdCardBack.IssuingAuthority';
DeIdCardBack.PSEUDONYM_FIELD_NAME = 'Pseudonym';
DeIdCardBack.PSEUDONYM_FIELD_NAME_NORMALIZED = 'DeIdCardBack.Pseudonym';
DeIdCardBack.RAW_MRZ_FIELD_NAME = 'RawMRZ';
DeIdCardBack.RAW_MRZ_FIELD_NAME_NORMALIZED = 'DeIdCardBack.RawMRZ';
DeIdCardBack.SERIES_FIELD_NAME = 'Series';
DeIdCardBack.SERIES_FIELD_NAME_NORMALIZED = 'DeIdCardBack.Series';
/** German travel passport (Reisepass) */
export class DePassport {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return DePassport.DOCUMENT_TYPE;
    }
    /** Birth date */
    get birthDate() {
        return this.document.fields.find((f) => f.type.name === 'BirthDate');
    }
    /** Birthplace */
    get birthplace() {
        return this.document.fields.find((f) => f.type.name === 'Birthplace');
    }
    /** Country code */
    get countryCode() {
        return this.document.fields.find((f) => f.type.name === 'CountryCode');
    }
    /** Expiry date */
    get expiryDate() {
        return this.document.fields.find((f) => f.type.name === 'ExpiryDate');
    }
    /** Gender */
    get gender() {
        return this.document.fields.find((f) => f.type.name === 'Gender');
    }
    /** Given names */
    get givenNames() {
        return this.document.fields.find((f) => f.type.name === 'GivenNames');
    }
    /** Document ID number (in the top-right corner) */
    get id() {
        return this.document.fields.find((f) => f.type.name === 'ID');
    }
    /** Issue date */
    get issueDate() {
        return this.document.fields.find((f) => f.type.name === 'IssueDate');
    }
    /** Issuing authority */
    get issuingAuthority() {
        return this.document.fields.find((f) => f.type.name === 'IssuingAuthority');
    }
    /** Maiden name */
    get maidenName() {
        return this.document.fields.find((f) => f.type.name === 'MaidenName');
    }
    /** Nationality */
    get nationality() {
        return this.document.fields.find((f) => f.type.name === 'Nationality');
    }
    /** Passport type */
    get passportType() {
        return this.document.fields.find((f) => f.type.name === 'PassportType');
    }
    /** Photo image */
    get photo() {
        return this.document.fields.find((f) => f.type.name === 'Photo');
    }
    /** Raw MRZ text value */
    get rawMRZ() {
        return this.document.fields.find((f) => f.type.name === 'RawMRZ');
    }
    /** Signature image */
    get signature() {
        return this.document.fields.find((f) => f.type.name === 'Signature');
    }
    /** Surname */
    get surname() {
        return this.document.fields.find((f) => f.type.name === 'Surname');
    }
    /** The child document of type "MRZ". */
    get mrz() {
        const child = this.document.children.find((c) => c.type.name === 'MRZ');
        return new MRZ(child);
    }
    /** The child document of type "Metadata". */
    get metadata() {
        const child = this.document.children.find((c) => c.type.name === 'Metadata');
        return new Metadata(child);
    }
}
DePassport.DOCUMENT_TYPE = 'DePassport';
DePassport.BIRTH_DATE_FIELD_NAME = 'BirthDate';
DePassport.BIRTH_DATE_FIELD_NAME_NORMALIZED = 'DePassport.BirthDate';
DePassport.BIRTHPLACE_FIELD_NAME = 'Birthplace';
DePassport.BIRTHPLACE_FIELD_NAME_NORMALIZED = 'DePassport.Birthplace';
DePassport.COUNTRY_CODE_FIELD_NAME = 'CountryCode';
DePassport.COUNTRY_CODE_FIELD_NAME_NORMALIZED = 'DePassport.CountryCode';
DePassport.EXPIRY_DATE_FIELD_NAME = 'ExpiryDate';
DePassport.EXPIRY_DATE_FIELD_NAME_NORMALIZED = 'DePassport.ExpiryDate';
DePassport.GENDER_FIELD_NAME = 'Gender';
DePassport.GENDER_FIELD_NAME_NORMALIZED = 'DePassport.Gender';
DePassport.GIVEN_NAMES_FIELD_NAME = 'GivenNames';
DePassport.GIVEN_NAMES_FIELD_NAME_NORMALIZED = 'DePassport.GivenNames';
DePassport.ID_FIELD_NAME = 'ID';
DePassport.ID_FIELD_NAME_NORMALIZED = 'DePassport.ID';
DePassport.ISSUE_DATE_FIELD_NAME = 'IssueDate';
DePassport.ISSUE_DATE_FIELD_NAME_NORMALIZED = 'DePassport.IssueDate';
DePassport.ISSUING_AUTHORITY_FIELD_NAME = 'IssuingAuthority';
DePassport.ISSUING_AUTHORITY_FIELD_NAME_NORMALIZED = 'DePassport.IssuingAuthority';
DePassport.MAIDEN_NAME_FIELD_NAME = 'MaidenName';
DePassport.MAIDEN_NAME_FIELD_NAME_NORMALIZED = 'DePassport.MaidenName';
DePassport.NATIONALITY_FIELD_NAME = 'Nationality';
DePassport.NATIONALITY_FIELD_NAME_NORMALIZED = 'DePassport.Nationality';
DePassport.PASSPORT_TYPE_FIELD_NAME = 'PassportType';
DePassport.PASSPORT_TYPE_FIELD_NAME_NORMALIZED = 'DePassport.PassportType';
DePassport.PHOTO_FIELD_NAME = 'Photo';
DePassport.PHOTO_FIELD_NAME_NORMALIZED = 'DePassport.Photo';
DePassport.RAW_MRZ_FIELD_NAME = 'RawMRZ';
DePassport.RAW_MRZ_FIELD_NAME_NORMALIZED = 'DePassport.RawMRZ';
DePassport.SIGNATURE_FIELD_NAME = 'Signature';
DePassport.SIGNATURE_FIELD_NAME_NORMALIZED = 'DePassport.Signature';
DePassport.SURNAME_FIELD_NAME = 'Surname';
DePassport.SURNAME_FIELD_NAME_NORMALIZED = 'DePassport.Surname';
/** European driver license, front side */
export class EuropeanDriverLicenseFront {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return EuropeanDriverLicenseFront.DOCUMENT_TYPE;
    }
    /** Address (Field 8.) */
    get address() {
        return this.document.fields.find((f) => f.type.name === 'Address');
    }
    /** Administrative number (Field 10.) */
    get administrativeNumber() {
        return this.document.fields.find((f) => f.type.name === 'AdministrativeNumber');
    }
    /** Barcode */
    get barcode() {
        return this.document.fields.find((f) => f.type.name === 'Barcode');
    }
    /** Birth date (Field 3.) */
    get birthDate() {
        return this.document.fields.find((f) => f.type.name === 'BirthDate');
    }
    /** Birthplace (Field 3.) */
    get birthplace() {
        return this.document.fields.find((f) => f.type.name === 'Birthplace');
    }
    /** Citizenship (Field 4f.) */
    get citizenship() {
        return this.document.fields.find((f) => f.type.name === 'Citizenship');
    }
    /** Country of the driver license */
    get country() {
        return this.document.fields.find((f) => f.type.name === 'Country');
    }
    /** Expiry date (Field 4b.) */
    get expiryDate() {
        return this.document.fields.find((f) => f.type.name === 'ExpiryDate');
    }
    /** Gender (Field 4e.) */
    get gender() {
        return this.document.fields.find((f) => f.type.name === 'Gender');
    }
    /** Given names (Field 2.) */
    get givenNames() {
        return this.document.fields.find((f) => f.type.name === 'GivenNames');
    }
    /** Document ID number (in the top-right corner, Field 5.) */
    get id() {
        return this.document.fields.find((f) => f.type.name === 'ID');
    }
    /** Issue date (Field 4a.) */
    get issueDate() {
        return this.document.fields.find((f) => f.type.name === 'IssueDate');
    }
    /** Issuing authority (Field 4c.) */
    get issuingAuthority() {
        return this.document.fields.find((f) => f.type.name === 'IssuingAuthority');
    }
    /** Driver's license categories (Field 9.) */
    get licenseCategories() {
        return this.document.fields.find((f) => f.type.name === 'LicenseCategories');
    }
    /** MRZ part of the document */
    get mrz() {
        return this.document.fields.find((f) => f.type.name === 'MRZ');
    }
    /** Photo image */
    get photo() {
        return this.document.fields.find((f) => f.type.name === 'Photo');
    }
    /** Restrictions applied for the driver's license (Field 12.) */
    get restrictions() {
        return this.document.fields.find((f) => f.type.name === 'Restrictions');
    }
    /** Serial number (Field 5b. on Driver Qualification Card) */
    get serialNumber() {
        return this.document.fields.find((f) => f.type.name === 'SerialNumber');
    }
    /** Signature image (Field 7.) */
    get signature() {
        return this.document.fields.find((f) => f.type.name === 'Signature');
    }
    /** Surname (Field 1.) */
    get surname() {
        return this.document.fields.find((f) => f.type.name === 'Surname');
    }
    /** The child document of type "Metadata". */
    get metadata() {
        const child = this.document.children.find((c) => c.type.name === 'Metadata');
        return new Metadata(child);
    }
}
EuropeanDriverLicenseFront.DOCUMENT_TYPE = 'EuropeanDriverLicenseFront';
EuropeanDriverLicenseFront.ADDRESS_FIELD_NAME = 'Address';
EuropeanDriverLicenseFront.ADDRESS_FIELD_NAME_NORMALIZED = 'EuropeanDriverLicenseFront.Address';
EuropeanDriverLicenseFront.ADMINISTRATIVE_NUMBER_FIELD_NAME = 'AdministrativeNumber';
EuropeanDriverLicenseFront.ADMINISTRATIVE_NUMBER_FIELD_NAME_NORMALIZED = 'EuropeanDriverLicenseFront.AdministrativeNumber';
EuropeanDriverLicenseFront.BARCODE_FIELD_NAME = 'Barcode';
EuropeanDriverLicenseFront.BARCODE_FIELD_NAME_NORMALIZED = 'EuropeanDriverLicenseFront.Barcode';
EuropeanDriverLicenseFront.BIRTH_DATE_FIELD_NAME = 'BirthDate';
EuropeanDriverLicenseFront.BIRTH_DATE_FIELD_NAME_NORMALIZED = 'EuropeanDriverLicenseFront.BirthDate';
EuropeanDriverLicenseFront.BIRTHPLACE_FIELD_NAME = 'Birthplace';
EuropeanDriverLicenseFront.BIRTHPLACE_FIELD_NAME_NORMALIZED = 'EuropeanDriverLicenseFront.Birthplace';
EuropeanDriverLicenseFront.CITIZENSHIP_FIELD_NAME = 'Citizenship';
EuropeanDriverLicenseFront.CITIZENSHIP_FIELD_NAME_NORMALIZED = 'EuropeanDriverLicenseFront.Citizenship';
EuropeanDriverLicenseFront.COUNTRY_FIELD_NAME = 'Country';
EuropeanDriverLicenseFront.COUNTRY_FIELD_NAME_NORMALIZED = 'EuropeanDriverLicenseFront.Country';
EuropeanDriverLicenseFront.EXPIRY_DATE_FIELD_NAME = 'ExpiryDate';
EuropeanDriverLicenseFront.EXPIRY_DATE_FIELD_NAME_NORMALIZED = 'EuropeanDriverLicenseFront.ExpiryDate';
EuropeanDriverLicenseFront.GENDER_FIELD_NAME = 'Gender';
EuropeanDriverLicenseFront.GENDER_FIELD_NAME_NORMALIZED = 'EuropeanDriverLicenseFront.Gender';
EuropeanDriverLicenseFront.GIVEN_NAMES_FIELD_NAME = 'GivenNames';
EuropeanDriverLicenseFront.GIVEN_NAMES_FIELD_NAME_NORMALIZED = 'EuropeanDriverLicenseFront.GivenNames';
EuropeanDriverLicenseFront.ID_FIELD_NAME = 'ID';
EuropeanDriverLicenseFront.ID_FIELD_NAME_NORMALIZED = 'EuropeanDriverLicenseFront.ID';
EuropeanDriverLicenseFront.ISSUE_DATE_FIELD_NAME = 'IssueDate';
EuropeanDriverLicenseFront.ISSUE_DATE_FIELD_NAME_NORMALIZED = 'EuropeanDriverLicenseFront.IssueDate';
EuropeanDriverLicenseFront.ISSUING_AUTHORITY_FIELD_NAME = 'IssuingAuthority';
EuropeanDriverLicenseFront.ISSUING_AUTHORITY_FIELD_NAME_NORMALIZED = 'EuropeanDriverLicenseFront.IssuingAuthority';
EuropeanDriverLicenseFront.LICENSE_CATEGORIES_FIELD_NAME = 'LicenseCategories';
EuropeanDriverLicenseFront.LICENSE_CATEGORIES_FIELD_NAME_NORMALIZED = 'EuropeanDriverLicenseFront.LicenseCategories';
EuropeanDriverLicenseFront.MRZ_FIELD_NAME = 'MRZ';
EuropeanDriverLicenseFront.MRZ_FIELD_NAME_NORMALIZED = 'EuropeanDriverLicenseFront.MRZ';
EuropeanDriverLicenseFront.PHOTO_FIELD_NAME = 'Photo';
EuropeanDriverLicenseFront.PHOTO_FIELD_NAME_NORMALIZED = 'EuropeanDriverLicenseFront.Photo';
EuropeanDriverLicenseFront.RESTRICTIONS_FIELD_NAME = 'Restrictions';
EuropeanDriverLicenseFront.RESTRICTIONS_FIELD_NAME_NORMALIZED = 'EuropeanDriverLicenseFront.Restrictions';
EuropeanDriverLicenseFront.SERIAL_NUMBER_FIELD_NAME = 'SerialNumber';
EuropeanDriverLicenseFront.SERIAL_NUMBER_FIELD_NAME_NORMALIZED = 'EuropeanDriverLicenseFront.SerialNumber';
EuropeanDriverLicenseFront.SIGNATURE_FIELD_NAME = 'Signature';
EuropeanDriverLicenseFront.SIGNATURE_FIELD_NAME_NORMALIZED = 'EuropeanDriverLicenseFront.Signature';
EuropeanDriverLicenseFront.SURNAME_FIELD_NAME = 'Surname';
EuropeanDriverLicenseFront.SURNAME_FIELD_NAME_NORMALIZED = 'EuropeanDriverLicenseFront.Surname';
/** European driver license, back side */
export class EuropeanDriverLicenseBack {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return EuropeanDriverLicenseBack.DOCUMENT_TYPE;
    }
    /** Country of the driver license */
    get country() {
        return this.document.fields.find((f) => f.type.name === 'Country');
    }
    /** Restrictions applied for the driver's license (Field 12.) */
    get restrictions() {
        return this.document.fields.find((f) => f.type.name === 'Restrictions');
    }
    /** The child document of type "Categories". */
    get categories() {
        const child = this.document.children.find((c) => c.type.name === 'Categories');
        return new EuropeanDriverLicenseBack.Categories(child);
    }
    /** The child document of type "Metadata". */
    get metadata() {
        const child = this.document.children.find((c) => c.type.name === 'Metadata');
        return new Metadata(child);
    }
}
EuropeanDriverLicenseBack.DOCUMENT_TYPE = 'EuropeanDriverLicenseBack';
EuropeanDriverLicenseBack.COUNTRY_FIELD_NAME = 'Country';
EuropeanDriverLicenseBack.COUNTRY_FIELD_NAME_NORMALIZED = 'EuropeanDriverLicenseBack.Country';
EuropeanDriverLicenseBack.RESTRICTIONS_FIELD_NAME = 'Restrictions';
EuropeanDriverLicenseBack.RESTRICTIONS_FIELD_NAME_NORMALIZED = 'EuropeanDriverLicenseBack.Restrictions';
(function (EuropeanDriverLicenseBack) {
    /** A category row from the categories table */
    class Category {
        get document() {
            return this._document;
        }
        constructor(document) {
            if (document.type.name !== this.requiredDocumentType()) {
                throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
            }
            this._document = document;
        }
        /** Restrictions (Column 12.) */
        get restrictions() {
            return this.document.fields.find((f) => f.type.name === 'Restrictions');
        }
        /** Valid from (Column 10.) */
        get validFrom() {
            return this.document.fields.find((f) => f.type.name === 'ValidFrom');
        }
        /** Valid until (Column 11.) */
        get validUntil() {
            return this.document.fields.find((f) => f.type.name === 'ValidUntil');
        }
    }
    Category.RESTRICTIONS_FIELD_NAME = 'Restrictions';
    Category.RESTRICTIONS_FIELD_NAME_NORMALIZED = 'EuropeanDriverLicenseBack.Category.Restrictions';
    Category.VALID_FROM_FIELD_NAME = 'ValidFrom';
    Category.VALID_FROM_FIELD_NAME_NORMALIZED = 'EuropeanDriverLicenseBack.Category.ValidFrom';
    Category.VALID_UNTIL_FIELD_NAME = 'ValidUntil';
    Category.VALID_UNTIL_FIELD_NAME_NORMALIZED = 'EuropeanDriverLicenseBack.Category.ValidUntil';
    EuropeanDriverLicenseBack.Category = Category;
    /** Categories table row container */
    class Categories {
        get document() {
            return this._document;
        }
        constructor(document) {
            if (document.type.name !== this.requiredDocumentType()) {
                throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
            }
            this._document = document;
        }
        requiredDocumentType() {
            return EuropeanDriverLicenseBack.Categories.DOCUMENT_TYPE;
        }
        /** The child document of type "A". */
        get a() {
            const child = this.document.children.find((c) => c.type.name === 'A');
            return new EuropeanDriverLicenseBack.Categories.A(child);
        }
        /** The child document of type "A1". */
        get a1() {
            const child = this.document.children.find((c) => c.type.name === 'A1');
            return new EuropeanDriverLicenseBack.Categories.A1(child);
        }
        /** The child document of type "A2". */
        get a2() {
            const child = this.document.children.find((c) => c.type.name === 'A2');
            return new EuropeanDriverLicenseBack.Categories.A2(child);
        }
        /** The child document of type "AM". */
        get am() {
            const child = this.document.children.find((c) => c.type.name === 'AM');
            return new EuropeanDriverLicenseBack.Categories.AM(child);
        }
        /** The child document of type "B". */
        get b() {
            const child = this.document.children.find((c) => c.type.name === 'B');
            return new EuropeanDriverLicenseBack.Categories.B(child);
        }
        /** The child document of type "B1". */
        get b1() {
            const child = this.document.children.find((c) => c.type.name === 'B1');
            return child ? new EuropeanDriverLicenseBack.Categories.B1(child) : undefined;
        }
        /** The child document of type "BE". */
        get be() {
            const child = this.document.children.find((c) => c.type.name === 'BE');
            return new EuropeanDriverLicenseBack.Categories.BE(child);
        }
        /** The child document of type "C". */
        get c() {
            const child = this.document.children.find((c) => c.type.name === 'C');
            return new EuropeanDriverLicenseBack.Categories.C(child);
        }
        /** The child document of type "C1". */
        get c1() {
            const child = this.document.children.find((c) => c.type.name === 'C1');
            return new EuropeanDriverLicenseBack.Categories.C1(child);
        }
        /** The child document of type "C1E". */
        get c1E() {
            const child = this.document.children.find((c) => c.type.name === 'C1E');
            return new EuropeanDriverLicenseBack.Categories.C1E(child);
        }
        /** The child document of type "CE". */
        get ce() {
            const child = this.document.children.find((c) => c.type.name === 'CE');
            return new EuropeanDriverLicenseBack.Categories.CE(child);
        }
        /** The child document of type "D". */
        get d() {
            const child = this.document.children.find((c) => c.type.name === 'D');
            return new EuropeanDriverLicenseBack.Categories.D(child);
        }
        /** The child document of type "D1". */
        get d1() {
            const child = this.document.children.find((c) => c.type.name === 'D1');
            return new EuropeanDriverLicenseBack.Categories.D1(child);
        }
        /** The child document of type "D1E". */
        get d1E() {
            const child = this.document.children.find((c) => c.type.name === 'D1E');
            return new EuropeanDriverLicenseBack.Categories.D1E(child);
        }
        /** The child document of type "DE". */
        get de() {
            const child = this.document.children.find((c) => c.type.name === 'DE');
            return new EuropeanDriverLicenseBack.Categories.DE(child);
        }
        /** The child document of type "L". */
        get l() {
            const child = this.document.children.find((c) => c.type.name === 'L');
            return new EuropeanDriverLicenseBack.Categories.L(child);
        }
        /** The child document of type "T". */
        get t() {
            const child = this.document.children.find((c) => c.type.name === 'T');
            return new EuropeanDriverLicenseBack.Categories.T(child);
        }
    }
    Categories.DOCUMENT_TYPE = 'Categories';
    EuropeanDriverLicenseBack.Categories = Categories;
    (function (Categories) {
        /** EuropeanDriverLicenseBack.Categories.A */
        class A extends Category {
            constructor(document) {
                super(document);
            }
            requiredDocumentType() {
                return EuropeanDriverLicenseBack.Categories.A.DOCUMENT_TYPE;
            }
        }
        A.DOCUMENT_TYPE = 'A';
        Categories.A = A;
        /** EuropeanDriverLicenseBack.Categories.A1 */
        class A1 extends Category {
            constructor(document) {
                super(document);
            }
            requiredDocumentType() {
                return EuropeanDriverLicenseBack.Categories.A1.DOCUMENT_TYPE;
            }
        }
        A1.DOCUMENT_TYPE = 'A1';
        Categories.A1 = A1;
        /** EuropeanDriverLicenseBack.Categories.A2 */
        class A2 extends Category {
            constructor(document) {
                super(document);
            }
            requiredDocumentType() {
                return EuropeanDriverLicenseBack.Categories.A2.DOCUMENT_TYPE;
            }
        }
        A2.DOCUMENT_TYPE = 'A2';
        Categories.A2 = A2;
        /** EuropeanDriverLicenseBack.Categories.AM */
        class AM extends Category {
            constructor(document) {
                super(document);
            }
            requiredDocumentType() {
                return EuropeanDriverLicenseBack.Categories.AM.DOCUMENT_TYPE;
            }
        }
        AM.DOCUMENT_TYPE = 'AM';
        Categories.AM = AM;
        /** EuropeanDriverLicenseBack.Categories.B */
        class B extends Category {
            constructor(document) {
                super(document);
            }
            requiredDocumentType() {
                return EuropeanDriverLicenseBack.Categories.B.DOCUMENT_TYPE;
            }
        }
        B.DOCUMENT_TYPE = 'B';
        Categories.B = B;
        /** EuropeanDriverLicenseBack.Categories.B1 */
        class B1 extends Category {
            constructor(document) {
                super(document);
            }
            requiredDocumentType() {
                return EuropeanDriverLicenseBack.Categories.B1.DOCUMENT_TYPE;
            }
        }
        B1.DOCUMENT_TYPE = 'B1';
        Categories.B1 = B1;
        /** EuropeanDriverLicenseBack.Categories.BE */
        class BE extends Category {
            constructor(document) {
                super(document);
            }
            requiredDocumentType() {
                return EuropeanDriverLicenseBack.Categories.BE.DOCUMENT_TYPE;
            }
        }
        BE.DOCUMENT_TYPE = 'BE';
        Categories.BE = BE;
        /** EuropeanDriverLicenseBack.Categories.C */
        class C extends Category {
            constructor(document) {
                super(document);
            }
            requiredDocumentType() {
                return EuropeanDriverLicenseBack.Categories.C.DOCUMENT_TYPE;
            }
        }
        C.DOCUMENT_TYPE = 'C';
        Categories.C = C;
        /** EuropeanDriverLicenseBack.Categories.C1 */
        class C1 extends Category {
            constructor(document) {
                super(document);
            }
            requiredDocumentType() {
                return EuropeanDriverLicenseBack.Categories.C1.DOCUMENT_TYPE;
            }
        }
        C1.DOCUMENT_TYPE = 'C1';
        Categories.C1 = C1;
        /** EuropeanDriverLicenseBack.Categories.C1E */
        class C1E extends Category {
            constructor(document) {
                super(document);
            }
            requiredDocumentType() {
                return EuropeanDriverLicenseBack.Categories.C1E.DOCUMENT_TYPE;
            }
        }
        C1E.DOCUMENT_TYPE = 'C1E';
        Categories.C1E = C1E;
        /** EuropeanDriverLicenseBack.Categories.CE */
        class CE extends Category {
            constructor(document) {
                super(document);
            }
            requiredDocumentType() {
                return EuropeanDriverLicenseBack.Categories.CE.DOCUMENT_TYPE;
            }
        }
        CE.DOCUMENT_TYPE = 'CE';
        Categories.CE = CE;
        /** EuropeanDriverLicenseBack.Categories.D */
        class D extends Category {
            constructor(document) {
                super(document);
            }
            requiredDocumentType() {
                return EuropeanDriverLicenseBack.Categories.D.DOCUMENT_TYPE;
            }
        }
        D.DOCUMENT_TYPE = 'D';
        Categories.D = D;
        /** EuropeanDriverLicenseBack.Categories.D1 */
        class D1 extends Category {
            constructor(document) {
                super(document);
            }
            requiredDocumentType() {
                return EuropeanDriverLicenseBack.Categories.D1.DOCUMENT_TYPE;
            }
        }
        D1.DOCUMENT_TYPE = 'D1';
        Categories.D1 = D1;
        /** EuropeanDriverLicenseBack.Categories.D1E */
        class D1E extends Category {
            constructor(document) {
                super(document);
            }
            requiredDocumentType() {
                return EuropeanDriverLicenseBack.Categories.D1E.DOCUMENT_TYPE;
            }
        }
        D1E.DOCUMENT_TYPE = 'D1E';
        Categories.D1E = D1E;
        /** EuropeanDriverLicenseBack.Categories.DE */
        class DE extends Category {
            constructor(document) {
                super(document);
            }
            requiredDocumentType() {
                return EuropeanDriverLicenseBack.Categories.DE.DOCUMENT_TYPE;
            }
        }
        DE.DOCUMENT_TYPE = 'DE';
        Categories.DE = DE;
        /** EuropeanDriverLicenseBack.Categories.L */
        class L extends Category {
            constructor(document) {
                super(document);
            }
            requiredDocumentType() {
                return EuropeanDriverLicenseBack.Categories.L.DOCUMENT_TYPE;
            }
        }
        L.DOCUMENT_TYPE = 'L';
        Categories.L = L;
        /** EuropeanDriverLicenseBack.Categories.T */
        class T extends Category {
            constructor(document) {
                super(document);
            }
            requiredDocumentType() {
                return EuropeanDriverLicenseBack.Categories.T.DOCUMENT_TYPE;
            }
        }
        T.DOCUMENT_TYPE = 'T';
        Categories.T = T;
    })(Categories = EuropeanDriverLicenseBack.Categories || (EuropeanDriverLicenseBack.Categories = {}));
})(EuropeanDriverLicenseBack || (EuropeanDriverLicenseBack = {}));
/** German Residence Permit (Aufenthaltstitel), Front side */
export class DeResidencePermitFront {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return DeResidencePermitFront.DOCUMENT_TYPE;
    }
    /** Birth date (Geburtsdatum) */
    get birthDate() {
        return this.document.fields.find((f) => f.type.name === 'BirthDate');
    }
    /** Six digit card access number */
    get cardAccessNumber() {
        return this.document.fields.find((f) => f.type.name === 'CardAccessNumber');
    }
    /** Expiry date (Gültig bis) */
    get expiryDate() {
        return this.document.fields.find((f) => f.type.name === 'ExpiryDate');
    }
    /** Gender (Geschlecht) */
    get gender() {
        return this.document.fields.find((f) => f.type.name === 'Gender');
    }
    /** Given names */
    get givenNames() {
        return this.document.fields.find((f) => f.type.name === 'GivenNames');
    }
    /** Document ID number (in the top-right corner) */
    get id() {
        return this.document.fields.find((f) => f.type.name === 'ID');
    }
    /** Nationality (Staatsangehörigkeit) */
    get nationality() {
        return this.document.fields.find((f) => f.type.name === 'Nationality');
    }
    /** Photo image */
    get photo() {
        return this.document.fields.find((f) => f.type.name === 'Photo');
    }
    /** Place of issue (Ausstellungsort) */
    get placeOfIssue() {
        return this.document.fields.find((f) => f.type.name === 'PlaceOfIssue');
    }
    /** Remarks (Anmerkungen) */
    get remarks() {
        return this.document.fields.find((f) => f.type.name === 'Remarks');
    }
    /** Signature image */
    get signature() {
        return this.document.fields.find((f) => f.type.name === 'Signature');
    }
    /** Surname */
    get surname() {
        return this.document.fields.find((f) => f.type.name === 'Surname');
    }
    /** Title type (Art des Titels) */
    get titleType() {
        return this.document.fields.find((f) => f.type.name === 'TitleType');
    }
    /** Valid from date (Gültig ab) */
    get validFrom() {
        return this.document.fields.find((f) => f.type.name === 'ValidFrom');
    }
    /** The child document of type "Metadata". */
    get metadata() {
        const child = this.document.children.find((c) => c.type.name === 'Metadata');
        return new Metadata(child);
    }
}
DeResidencePermitFront.DOCUMENT_TYPE = 'DeResidencePermitFront';
DeResidencePermitFront.BIRTH_DATE_FIELD_NAME = 'BirthDate';
DeResidencePermitFront.BIRTH_DATE_FIELD_NAME_NORMALIZED = 'DeResidencePermitFront.BirthDate';
DeResidencePermitFront.CARD_ACCESS_NUMBER_FIELD_NAME = 'CardAccessNumber';
DeResidencePermitFront.CARD_ACCESS_NUMBER_FIELD_NAME_NORMALIZED = 'DeResidencePermitFront.CardAccessNumber';
DeResidencePermitFront.EXPIRY_DATE_FIELD_NAME = 'ExpiryDate';
DeResidencePermitFront.EXPIRY_DATE_FIELD_NAME_NORMALIZED = 'DeResidencePermitFront.ExpiryDate';
DeResidencePermitFront.GENDER_FIELD_NAME = 'Gender';
DeResidencePermitFront.GENDER_FIELD_NAME_NORMALIZED = 'DeResidencePermitFront.Gender';
DeResidencePermitFront.GIVEN_NAMES_FIELD_NAME = 'GivenNames';
DeResidencePermitFront.GIVEN_NAMES_FIELD_NAME_NORMALIZED = 'DeResidencePermitFront.GivenNames';
DeResidencePermitFront.ID_FIELD_NAME = 'ID';
DeResidencePermitFront.ID_FIELD_NAME_NORMALIZED = 'DeResidencePermitFront.ID';
DeResidencePermitFront.NATIONALITY_FIELD_NAME = 'Nationality';
DeResidencePermitFront.NATIONALITY_FIELD_NAME_NORMALIZED = 'DeResidencePermitFront.Nationality';
DeResidencePermitFront.PHOTO_FIELD_NAME = 'Photo';
DeResidencePermitFront.PHOTO_FIELD_NAME_NORMALIZED = 'DeResidencePermitFront.Photo';
DeResidencePermitFront.PLACE_OF_ISSUE_FIELD_NAME = 'PlaceOfIssue';
DeResidencePermitFront.PLACE_OF_ISSUE_FIELD_NAME_NORMALIZED = 'DeResidencePermitFront.PlaceOfIssue';
DeResidencePermitFront.REMARKS_FIELD_NAME = 'Remarks';
DeResidencePermitFront.REMARKS_FIELD_NAME_NORMALIZED = 'DeResidencePermitFront.Remarks';
DeResidencePermitFront.SIGNATURE_FIELD_NAME = 'Signature';
DeResidencePermitFront.SIGNATURE_FIELD_NAME_NORMALIZED = 'DeResidencePermitFront.Signature';
DeResidencePermitFront.SURNAME_FIELD_NAME = 'Surname';
DeResidencePermitFront.SURNAME_FIELD_NAME_NORMALIZED = 'DeResidencePermitFront.Surname';
DeResidencePermitFront.TITLE_TYPE_FIELD_NAME = 'TitleType';
DeResidencePermitFront.TITLE_TYPE_FIELD_NAME_NORMALIZED = 'DeResidencePermitFront.TitleType';
DeResidencePermitFront.VALID_FROM_FIELD_NAME = 'ValidFrom';
DeResidencePermitFront.VALID_FROM_FIELD_NAME_NORMALIZED = 'DeResidencePermitFront.ValidFrom';
/** German Residence Permit (Aufenthaltstitel), Back side */
export class DeResidencePermitBack {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return DeResidencePermitBack.DOCUMENT_TYPE;
    }
    /** Address (Anschrift) */
    get address() {
        return this.document.fields.find((f) => f.type.name === 'Address');
    }
    /** Birth date (Geburtsdatum) */
    get birthDate() {
        return this.document.fields.find((f) => f.type.name === 'BirthDate');
    }
    /** Birthplace (Geburtsort) */
    get birthplace() {
        return this.document.fields.find((f) => f.type.name === 'Birthplace');
    }
    /** Eye color (Augenfarbe) */
    get eyeColor() {
        return this.document.fields.find((f) => f.type.name === 'EyeColor');
    }
    /** Gender (Geschlecht) */
    get gender() {
        return this.document.fields.find((f) => f.type.name === 'Gender');
    }
    /** Height (Größe) */
    get height() {
        return this.document.fields.find((f) => f.type.name === 'Height');
    }
    /** Issuing authority (Ausländerbehörde) */
    get issuingAuthority() {
        return this.document.fields.find((f) => f.type.name === 'IssuingAuthority');
    }
    /** Nationality (Staatsangehörigkeit) */
    get nationality() {
        return this.document.fields.find((f) => f.type.name === 'Nationality');
    }
    /** Raw MRZ text value */
    get rawMRZ() {
        return this.document.fields.find((f) => f.type.name === 'RawMRZ');
    }
    /** Remarks (Anmerkungen) */
    get remarks() {
        return this.document.fields.find((f) => f.type.name === 'Remarks');
    }
    /** The child document of type "MRZ". */
    get mrz() {
        const child = this.document.children.find((c) => c.type.name === 'MRZ');
        return new MRZ(child);
    }
    /** The child document of type "ParsedDeAddress". */
    get parsedDeAddress() {
        const child = this.document.children.find((c) => c.type.name === 'ParsedDeAddress');
        return new ParsedDeAddress(child);
    }
    /** The child document of type "Metadata". */
    get metadata() {
        const child = this.document.children.find((c) => c.type.name === 'Metadata');
        return new Metadata(child);
    }
}
DeResidencePermitBack.DOCUMENT_TYPE = 'DeResidencePermitBack';
DeResidencePermitBack.ADDRESS_FIELD_NAME = 'Address';
DeResidencePermitBack.ADDRESS_FIELD_NAME_NORMALIZED = 'DeResidencePermitBack.Address';
DeResidencePermitBack.BIRTH_DATE_FIELD_NAME = 'BirthDate';
DeResidencePermitBack.BIRTH_DATE_FIELD_NAME_NORMALIZED = 'DeResidencePermitBack.BirthDate';
DeResidencePermitBack.BIRTHPLACE_FIELD_NAME = 'Birthplace';
DeResidencePermitBack.BIRTHPLACE_FIELD_NAME_NORMALIZED = 'DeResidencePermitBack.Birthplace';
DeResidencePermitBack.EYE_COLOR_FIELD_NAME = 'EyeColor';
DeResidencePermitBack.EYE_COLOR_FIELD_NAME_NORMALIZED = 'DeResidencePermitBack.EyeColor';
DeResidencePermitBack.GENDER_FIELD_NAME = 'Gender';
DeResidencePermitBack.GENDER_FIELD_NAME_NORMALIZED = 'DeResidencePermitBack.Gender';
DeResidencePermitBack.HEIGHT_FIELD_NAME = 'Height';
DeResidencePermitBack.HEIGHT_FIELD_NAME_NORMALIZED = 'DeResidencePermitBack.Height';
DeResidencePermitBack.ISSUING_AUTHORITY_FIELD_NAME = 'IssuingAuthority';
DeResidencePermitBack.ISSUING_AUTHORITY_FIELD_NAME_NORMALIZED = 'DeResidencePermitBack.IssuingAuthority';
DeResidencePermitBack.NATIONALITY_FIELD_NAME = 'Nationality';
DeResidencePermitBack.NATIONALITY_FIELD_NAME_NORMALIZED = 'DeResidencePermitBack.Nationality';
DeResidencePermitBack.RAW_MRZ_FIELD_NAME = 'RawMRZ';
DeResidencePermitBack.RAW_MRZ_FIELD_NAME_NORMALIZED = 'DeResidencePermitBack.RawMRZ';
DeResidencePermitBack.REMARKS_FIELD_NAME = 'Remarks';
DeResidencePermitBack.REMARKS_FIELD_NAME_NORMALIZED = 'DeResidencePermitBack.Remarks';
/** European Health Insurance Card (EHIC). Supports formats with both four and five lines of data.
 */
export class EuropeanHealthInsuranceCard {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return EuropeanHealthInsuranceCard.DOCUMENT_TYPE;
    }
    /** Barcode image (only present in some formats) */
    get barcode() {
        return this.document.fields.find((f) => f.type.name === 'Barcode');
    }
    /** Birth date */
    get birthDate() {
        return this.document.fields.find((f) => f.type.name === 'BirthDate');
    }
    /** Card number */
    get cardNumber() {
        return this.document.fields.find((f) => f.type.name === 'CardNumber');
    }
    /** Country code (ISO 3166-1 alpha-2) */
    get countryCode() {
        return this.document.fields.find((f) => f.type.name === 'CountryCode');
    }
    /** Expiry date */
    get expiryDate() {
        return this.document.fields.find((f) => f.type.name === 'ExpiryDate');
    }
    /** Given names */
    get givenNames() {
        return this.document.fields.find((f) => f.type.name === 'GivenNames');
    }
    /** Issuer name */
    get issuerName() {
        return this.document.fields.find((f) => f.type.name === 'IssuerName');
    }
    /** Issuer number */
    get issuerNumber() {
        return this.document.fields.find((f) => f.type.name === 'IssuerNumber');
    }
    /** Personal number */
    get personalNumber() {
        return this.document.fields.find((f) => f.type.name === 'PersonalNumber');
    }
    /** Signature image */
    get signature() {
        return this.document.fields.find((f) => f.type.name === 'Signature');
    }
    /** Surname */
    get surname() {
        return this.document.fields.find((f) => f.type.name === 'Surname');
    }
    /** The child document of type "Metadata". */
    get metadata() {
        const child = this.document.children.find((c) => c.type.name === 'Metadata');
        return new Metadata(child);
    }
}
EuropeanHealthInsuranceCard.DOCUMENT_TYPE = 'EuropeanHealthInsuranceCard';
EuropeanHealthInsuranceCard.BARCODE_FIELD_NAME = 'Barcode';
EuropeanHealthInsuranceCard.BARCODE_FIELD_NAME_NORMALIZED = 'EuropeanHealthInsuranceCard.Barcode';
EuropeanHealthInsuranceCard.BIRTH_DATE_FIELD_NAME = 'BirthDate';
EuropeanHealthInsuranceCard.BIRTH_DATE_FIELD_NAME_NORMALIZED = 'EuropeanHealthInsuranceCard.BirthDate';
EuropeanHealthInsuranceCard.CARD_NUMBER_FIELD_NAME = 'CardNumber';
EuropeanHealthInsuranceCard.CARD_NUMBER_FIELD_NAME_NORMALIZED = 'EuropeanHealthInsuranceCard.CardNumber';
EuropeanHealthInsuranceCard.COUNTRY_CODE_FIELD_NAME = 'CountryCode';
EuropeanHealthInsuranceCard.COUNTRY_CODE_FIELD_NAME_NORMALIZED = 'EuropeanHealthInsuranceCard.CountryCode';
EuropeanHealthInsuranceCard.EXPIRY_DATE_FIELD_NAME = 'ExpiryDate';
EuropeanHealthInsuranceCard.EXPIRY_DATE_FIELD_NAME_NORMALIZED = 'EuropeanHealthInsuranceCard.ExpiryDate';
EuropeanHealthInsuranceCard.GIVEN_NAMES_FIELD_NAME = 'GivenNames';
EuropeanHealthInsuranceCard.GIVEN_NAMES_FIELD_NAME_NORMALIZED = 'EuropeanHealthInsuranceCard.GivenNames';
EuropeanHealthInsuranceCard.ISSUER_NAME_FIELD_NAME = 'IssuerName';
EuropeanHealthInsuranceCard.ISSUER_NAME_FIELD_NAME_NORMALIZED = 'EuropeanHealthInsuranceCard.IssuerName';
EuropeanHealthInsuranceCard.ISSUER_NUMBER_FIELD_NAME = 'IssuerNumber';
EuropeanHealthInsuranceCard.ISSUER_NUMBER_FIELD_NAME_NORMALIZED = 'EuropeanHealthInsuranceCard.IssuerNumber';
EuropeanHealthInsuranceCard.PERSONAL_NUMBER_FIELD_NAME = 'PersonalNumber';
EuropeanHealthInsuranceCard.PERSONAL_NUMBER_FIELD_NAME_NORMALIZED = 'EuropeanHealthInsuranceCard.PersonalNumber';
EuropeanHealthInsuranceCard.SIGNATURE_FIELD_NAME = 'Signature';
EuropeanHealthInsuranceCard.SIGNATURE_FIELD_NAME_NORMALIZED = 'EuropeanHealthInsuranceCard.Signature';
EuropeanHealthInsuranceCard.SURNAME_FIELD_NAME = 'Surname';
EuropeanHealthInsuranceCard.SURNAME_FIELD_NAME_NORMALIZED = 'EuropeanHealthInsuranceCard.Surname';
/** Front side of the German health insurance card (elektronische Gesundheitskarte).
For the backside, see EuropeanHealthInsuranceCard.
 */
export class DeHealthInsuranceCardFront {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return DeHealthInsuranceCardFront.DOCUMENT_TYPE;
    }
    /** Six digit card access number */
    get cardAccessNumber() {
        return this.document.fields.find((f) => f.type.name === 'CardAccessNumber');
    }
    /** Issuer name */
    get issuerName() {
        return this.document.fields.find((f) => f.type.name === 'IssuerName');
    }
    /** Issuer number (Versicherung bzw. Kennnummer des Trägers) */
    get issuerNumber() {
        return this.document.fields.find((f) => f.type.name === 'IssuerNumber');
    }
    /** Full name with title */
    get name() {
        return this.document.fields.find((f) => f.type.name === 'Name');
    }
    /** Personal number (Versichertennummer) */
    get personalNumber() {
        return this.document.fields.find((f) => f.type.name === 'PersonalNumber');
    }
    /** The child document of type "Metadata". */
    get metadata() {
        const child = this.document.children.find((c) => c.type.name === 'Metadata');
        return new Metadata(child);
    }
}
DeHealthInsuranceCardFront.DOCUMENT_TYPE = 'DeHealthInsuranceCardFront';
DeHealthInsuranceCardFront.CARD_ACCESS_NUMBER_FIELD_NAME = 'CardAccessNumber';
DeHealthInsuranceCardFront.CARD_ACCESS_NUMBER_FIELD_NAME_NORMALIZED = 'DeHealthInsuranceCardFront.CardAccessNumber';
DeHealthInsuranceCardFront.ISSUER_NAME_FIELD_NAME = 'IssuerName';
DeHealthInsuranceCardFront.ISSUER_NAME_FIELD_NAME_NORMALIZED = 'DeHealthInsuranceCardFront.IssuerName';
DeHealthInsuranceCardFront.ISSUER_NUMBER_FIELD_NAME = 'IssuerNumber';
DeHealthInsuranceCardFront.ISSUER_NUMBER_FIELD_NAME_NORMALIZED = 'DeHealthInsuranceCardFront.IssuerNumber';
DeHealthInsuranceCardFront.NAME_FIELD_NAME = 'Name';
DeHealthInsuranceCardFront.NAME_FIELD_NAME_NORMALIZED = 'DeHealthInsuranceCardFront.Name';
DeHealthInsuranceCardFront.PERSONAL_NUMBER_FIELD_NAME = 'PersonalNumber';
DeHealthInsuranceCardFront.PERSONAL_NUMBER_FIELD_NAME_NORMALIZED = 'DeHealthInsuranceCardFront.PersonalNumber';
/** Brazilian National Identity Card (Registro Geral) */
export class BrIdCardFront {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return BrIdCardFront.DOCUMENT_TYPE;
    }
    /** Código de Barras - Barcode */
    get barcode() {
        return this.document.fields.find((f) => f.type.name === 'Barcode');
    }
    /** Birth date */
    get birthDate() {
        return this.document.fields.find((f) => f.type.name === 'BirthDate');
    }
    /** Birthplace */
    get birthplace() {
        return this.document.fields.find((f) => f.type.name === 'Birthplace');
    }
    /** Tipo Sanguíneo/Fator RH - Blood type and RH factor */
    get bloodType() {
        return this.document.fields.find((f) => f.type.name === 'BloodType');
    }
    /** Dados do Registro Civil - Civil Registry Details */
    get civilRegistryDetails() {
        return this.document.fields.find((f) => f.type.name === 'CivilRegistryDetails');
    }
    /** CNH (Carteira Nacional de Habilitação) - Driver’s license number */
    get driverLicenseNumber() {
        return this.document.fields.find((f) => f.type.name === 'DriverLicenseNumber');
    }
    /** Expiry date */
    get expiryDate() {
        return this.document.fields.find((f) => f.type.name === 'ExpiryDate');
    }
    /** Polegar Direito - Right thumbprint */
    get fingerprint() {
        return this.document.fields.find((f) => f.type.name === 'Fingerprint');
    }
    /** Gender */
    get gender() {
        return this.document.fields.find((f) => f.type.name === 'Gender');
    }
    /** Given names */
    get givenNames() {
        return this.document.fields.find((f) => f.type.name === 'GivenNames');
    }
    /** CNS (Cartão Nacional de Saúde) - National Health Card number */
    get healthCardNumber() {
        return this.document.fields.find((f) => f.type.name === 'HealthCardNumber');
    }
    /** DNI (Documento Nacional de Identidade) - National Identity Document number */
    get id() {
        return this.document.fields.find((f) => f.type.name === 'ID');
    }
    /** Data de Expedição - Date the document was issued */
    get issueDate() {
        return this.document.fields.find((f) => f.type.name === 'IssueDate');
    }
    /** Órgão Expedidor - Issuing Authority */
    get issuingAuthority() {
        return this.document.fields.find((f) => f.type.name === 'IssuingAuthority');
    }
    /** Assinatura do Diretor - Signature of the issuing authority */
    get issuingAuthoritySignature() {
        return this.document.fields.find((f) => f.type.name === 'IssuingAuthoritySignature');
    }
    /** Certificado Militar - Military certificate number */
    get militaryCertificateNumber() {
        return this.document.fields.find((f) => f.type.name === 'MilitaryCertificateNumber');
    }
    /** Nacionalidade - Nationality */
    get nationality() {
        return this.document.fields.find((f) => f.type.name === 'Nationality');
    }
    /** Observações - Observations */
    get observations() {
        return this.document.fields.find((f) => f.type.name === 'Observations');
    }
    /** Pais - Parents */
    get parents() {
        return this.document.fields.find((f) => f.type.name === 'Parents');
    }
    /** Registro Geral (RG) - General Registration number, main ID number */
    get personalNumber() {
        return this.document.fields.find((f) => f.type.name === 'PersonalNumber');
    }
    /** Photo image */
    get photo() {
        return this.document.fields.find((f) => f.type.name === 'Photo');
    }
    /** Local de Emissão - Place of Issue */
    get placeOfIssue() {
        return this.document.fields.find((f) => f.type.name === 'PlaceOfIssue');
    }
    /** Identidade Profissional - Professional identity number */
    get professionalIdentityNumber() {
        return this.document.fields.find((f) => f.type.name === 'ProfessionalIdentityNumber');
    }
    /** Assinatura - Signature */
    get signature() {
        return this.document.fields.find((f) => f.type.name === 'Signature');
    }
    /** NIS/PIS/PASEP - Social Security and Employment benefits number */
    get socialSecurityNumber() {
        return this.document.fields.find((f) => f.type.name === 'SocialSecurityNumber');
    }
    /** UF - Brazilian state code for the Work Card */
    get stateCode() {
        return this.document.fields.find((f) => f.type.name === 'StateCode');
    }
    /** Surname */
    get surname() {
        return this.document.fields.find((f) => f.type.name === 'Surname');
    }
    /** CPF (Cadastro de Pessoas Físicas) - Brazilian taxpayer number */
    get taxpayerNumber() {
        return this.document.fields.find((f) => f.type.name === 'TaxpayerNumber');
    }
    /** Título de Eleitor - Voter registration number */
    get voterRegistrationNumber() {
        return this.document.fields.find((f) => f.type.name === 'VoterRegistrationNumber');
    }
    /** CTPS (Carteira de Trabalho e Previdência Social) - Work Card number */
    get workCardNumber() {
        return this.document.fields.find((f) => f.type.name === 'WorkCardNumber');
    }
    /** Série - Series number associated with the Work Card */
    get workCardSeries() {
        return this.document.fields.find((f) => f.type.name === 'WorkCardSeries');
    }
    /** The child document of type "Metadata". */
    get metadata() {
        const child = this.document.children.find((c) => c.type.name === 'Metadata');
        return new Metadata(child);
    }
}
BrIdCardFront.DOCUMENT_TYPE = 'BrIdCardFront';
BrIdCardFront.BARCODE_FIELD_NAME = 'Barcode';
BrIdCardFront.BARCODE_FIELD_NAME_NORMALIZED = 'BrIdCardFront.Barcode';
BrIdCardFront.BIRTH_DATE_FIELD_NAME = 'BirthDate';
BrIdCardFront.BIRTH_DATE_FIELD_NAME_NORMALIZED = 'BrIdCardFront.BirthDate';
BrIdCardFront.BIRTHPLACE_FIELD_NAME = 'Birthplace';
BrIdCardFront.BIRTHPLACE_FIELD_NAME_NORMALIZED = 'BrIdCardFront.Birthplace';
BrIdCardFront.BLOOD_TYPE_FIELD_NAME = 'BloodType';
BrIdCardFront.BLOOD_TYPE_FIELD_NAME_NORMALIZED = 'BrIdCardFront.BloodType';
BrIdCardFront.CIVIL_REGISTRY_DETAILS_FIELD_NAME = 'CivilRegistryDetails';
BrIdCardFront.CIVIL_REGISTRY_DETAILS_FIELD_NAME_NORMALIZED = 'BrIdCardFront.CivilRegistryDetails';
BrIdCardFront.DRIVER_LICENSE_NUMBER_FIELD_NAME = 'DriverLicenseNumber';
BrIdCardFront.DRIVER_LICENSE_NUMBER_FIELD_NAME_NORMALIZED = 'BrIdCardFront.DriverLicenseNumber';
BrIdCardFront.EXPIRY_DATE_FIELD_NAME = 'ExpiryDate';
BrIdCardFront.EXPIRY_DATE_FIELD_NAME_NORMALIZED = 'BrIdCardFront.ExpiryDate';
BrIdCardFront.FINGERPRINT_FIELD_NAME = 'Fingerprint';
BrIdCardFront.FINGERPRINT_FIELD_NAME_NORMALIZED = 'BrIdCardFront.Fingerprint';
BrIdCardFront.GENDER_FIELD_NAME = 'Gender';
BrIdCardFront.GENDER_FIELD_NAME_NORMALIZED = 'BrIdCardFront.Gender';
BrIdCardFront.GIVEN_NAMES_FIELD_NAME = 'GivenNames';
BrIdCardFront.GIVEN_NAMES_FIELD_NAME_NORMALIZED = 'BrIdCardFront.GivenNames';
BrIdCardFront.HEALTH_CARD_NUMBER_FIELD_NAME = 'HealthCardNumber';
BrIdCardFront.HEALTH_CARD_NUMBER_FIELD_NAME_NORMALIZED = 'BrIdCardFront.HealthCardNumber';
BrIdCardFront.ID_FIELD_NAME = 'ID';
BrIdCardFront.ID_FIELD_NAME_NORMALIZED = 'BrIdCardFront.ID';
BrIdCardFront.ISSUE_DATE_FIELD_NAME = 'IssueDate';
BrIdCardFront.ISSUE_DATE_FIELD_NAME_NORMALIZED = 'BrIdCardFront.IssueDate';
BrIdCardFront.ISSUING_AUTHORITY_FIELD_NAME = 'IssuingAuthority';
BrIdCardFront.ISSUING_AUTHORITY_FIELD_NAME_NORMALIZED = 'BrIdCardFront.IssuingAuthority';
BrIdCardFront.ISSUING_AUTHORITY_SIGNATURE_FIELD_NAME = 'IssuingAuthoritySignature';
BrIdCardFront.ISSUING_AUTHORITY_SIGNATURE_FIELD_NAME_NORMALIZED = 'BrIdCardFront.IssuingAuthoritySignature';
BrIdCardFront.MILITARY_CERTIFICATE_NUMBER_FIELD_NAME = 'MilitaryCertificateNumber';
BrIdCardFront.MILITARY_CERTIFICATE_NUMBER_FIELD_NAME_NORMALIZED = 'BrIdCardFront.MilitaryCertificateNumber';
BrIdCardFront.NATIONALITY_FIELD_NAME = 'Nationality';
BrIdCardFront.NATIONALITY_FIELD_NAME_NORMALIZED = 'BrIdCardFront.Nationality';
BrIdCardFront.OBSERVATIONS_FIELD_NAME = 'Observations';
BrIdCardFront.OBSERVATIONS_FIELD_NAME_NORMALIZED = 'BrIdCardFront.Observations';
BrIdCardFront.PARENTS_FIELD_NAME = 'Parents';
BrIdCardFront.PARENTS_FIELD_NAME_NORMALIZED = 'BrIdCardFront.Parents';
BrIdCardFront.PERSONAL_NUMBER_FIELD_NAME = 'PersonalNumber';
BrIdCardFront.PERSONAL_NUMBER_FIELD_NAME_NORMALIZED = 'BrIdCardFront.PersonalNumber';
BrIdCardFront.PHOTO_FIELD_NAME = 'Photo';
BrIdCardFront.PHOTO_FIELD_NAME_NORMALIZED = 'BrIdCardFront.Photo';
BrIdCardFront.PLACE_OF_ISSUE_FIELD_NAME = 'PlaceOfIssue';
BrIdCardFront.PLACE_OF_ISSUE_FIELD_NAME_NORMALIZED = 'BrIdCardFront.PlaceOfIssue';
BrIdCardFront.PROFESSIONAL_IDENTITY_NUMBER_FIELD_NAME = 'ProfessionalIdentityNumber';
BrIdCardFront.PROFESSIONAL_IDENTITY_NUMBER_FIELD_NAME_NORMALIZED = 'BrIdCardFront.ProfessionalIdentityNumber';
BrIdCardFront.SIGNATURE_FIELD_NAME = 'Signature';
BrIdCardFront.SIGNATURE_FIELD_NAME_NORMALIZED = 'BrIdCardFront.Signature';
BrIdCardFront.SOCIAL_SECURITY_NUMBER_FIELD_NAME = 'SocialSecurityNumber';
BrIdCardFront.SOCIAL_SECURITY_NUMBER_FIELD_NAME_NORMALIZED = 'BrIdCardFront.SocialSecurityNumber';
BrIdCardFront.STATE_CODE_FIELD_NAME = 'StateCode';
BrIdCardFront.STATE_CODE_FIELD_NAME_NORMALIZED = 'BrIdCardFront.StateCode';
BrIdCardFront.SURNAME_FIELD_NAME = 'Surname';
BrIdCardFront.SURNAME_FIELD_NAME_NORMALIZED = 'BrIdCardFront.Surname';
BrIdCardFront.TAXPAYER_NUMBER_FIELD_NAME = 'TaxpayerNumber';
BrIdCardFront.TAXPAYER_NUMBER_FIELD_NAME_NORMALIZED = 'BrIdCardFront.TaxpayerNumber';
BrIdCardFront.VOTER_REGISTRATION_NUMBER_FIELD_NAME = 'VoterRegistrationNumber';
BrIdCardFront.VOTER_REGISTRATION_NUMBER_FIELD_NAME_NORMALIZED = 'BrIdCardFront.VoterRegistrationNumber';
BrIdCardFront.WORK_CARD_NUMBER_FIELD_NAME = 'WorkCardNumber';
BrIdCardFront.WORK_CARD_NUMBER_FIELD_NAME_NORMALIZED = 'BrIdCardFront.WorkCardNumber';
BrIdCardFront.WORK_CARD_SERIES_FIELD_NAME = 'WorkCardSeries';
BrIdCardFront.WORK_CARD_SERIES_FIELD_NAME_NORMALIZED = 'BrIdCardFront.WorkCardSeries';
/** Brazilian National Identity Card (Registro Geral), back side */
export class BrIdCardBack {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return BrIdCardBack.DOCUMENT_TYPE;
    }
    /** Barcode */
    get barcode() {
        return this.document.fields.find((f) => f.type.name === 'Barcode');
    }
    /** Date of Birth */
    get birthDate() {
        return this.document.fields.find((f) => f.type.name === 'BirthDate');
    }
    /** Birthplace */
    get birthplace() {
        return this.document.fields.find((f) => f.type.name === 'Birthplace');
    }
    /** Dados do Registro Civil - Civil Registry Details */
    get civilRegistryDetails() {
        return this.document.fields.find((f) => f.type.name === 'CivilRegistryDetails');
    }
    /** CNH (Carteira Nacional de Habilitação) - Driver’s license number */
    get driverLicenseNumber() {
        return this.document.fields.find((f) => f.type.name === 'DriverLicenseNumber');
    }
    /** Expiry Date */
    get expiryDate() {
        return this.document.fields.find((f) => f.type.name === 'ExpiryDate');
    }
    /** Fingerprint */
    get fingerprint() {
        return this.document.fields.find((f) => f.type.name === 'Fingerprint');
    }
    /** Given Names */
    get givenNames() {
        return this.document.fields.find((f) => f.type.name === 'GivenNames');
    }
    /** CNS (Cartão Nacional de Saúde) - National Health Card number */
    get healthCardNumber() {
        return this.document.fields.find((f) => f.type.name === 'HealthCardNumber');
    }
    /** DNI (Documento Nacional de Identidade) - National Identity Document number */
    get id() {
        return this.document.fields.find((f) => f.type.name === 'ID');
    }
    /** Issue Date */
    get issueDate() {
        return this.document.fields.find((f) => f.type.name === 'IssueDate');
    }
    /** Órgão Expedidor - Issuing Authority */
    get issuingAuthority() {
        return this.document.fields.find((f) => f.type.name === 'IssuingAuthority');
    }
    /** Certificado Militar - Military certificate number */
    get militaryCertificateNumber() {
        return this.document.fields.find((f) => f.type.name === 'MilitaryCertificateNumber');
    }
    /** Page Number of the document */
    get pageNumber() {
        return this.document.fields.find((f) => f.type.name === 'PageNumber');
    }
    /** Filiação - Parents */
    get parents() {
        return this.document.fields.find((f) => f.type.name === 'Parents');
    }
    /** Registro Geral (RG) - General Registration number, main ID number */
    get personalNumber() {
        return this.document.fields.find((f) => f.type.name === 'PersonalNumber');
    }
    /** Photo */
    get photo() {
        return this.document.fields.find((f) => f.type.name === 'Photo');
    }
    /** Local de Emissão - Place where the identity card was issued */
    get placeOfIssue() {
        return this.document.fields.find((f) => f.type.name === 'PlaceOfIssue');
    }
    /** Naturalidade - Place of Origin */
    get placeOfOrigin() {
        return this.document.fields.find((f) => f.type.name === 'PlaceOfOrigin');
    }
    /** Identidade Profissional - Professional identity number */
    get professionalIdentityNumber() {
        return this.document.fields.find((f) => f.type.name === 'ProfessionalIdentityNumber');
    }
    /** Raw MRZ text value */
    get rawMRZ() {
        return this.document.fields.find((f) => f.type.name === 'RawMRZ');
    }
    /** Assinatura - Signature */
    get signature() {
        return this.document.fields.find((f) => f.type.name === 'Signature');
    }
    /** NIS/PIS/PASEP - Social Security and Employment benefits number */
    get socialSecurityNumber() {
        return this.document.fields.find((f) => f.type.name === 'SocialSecurityNumber');
    }
    /** UF - Brazilian state code related to the Work Card */
    get stateCode() {
        return this.document.fields.find((f) => f.type.name === 'StateCode');
    }
    /** CPF (Cadastro de Pessoas Físicas) - Brazilian taxpayer number */
    get taxpayerNumber() {
        return this.document.fields.find((f) => f.type.name === 'TaxpayerNumber');
    }
    /** Título de Eleitor - Voter registration number */
    get voterRegistrationNumber() {
        return this.document.fields.find((f) => f.type.name === 'VoterRegistrationNumber');
    }
    /** CTPS (Carteira de Trabalho e Previdência Social) - Work Card number */
    get workCardNumber() {
        return this.document.fields.find((f) => f.type.name === 'WorkCardNumber');
    }
    /** Série - Series number associated with the Work Card */
    get workCardSeries() {
        return this.document.fields.find((f) => f.type.name === 'WorkCardSeries');
    }
    /** The child document of type "MRZ". */
    get mrz() {
        const child = this.document.children.find((c) => c.type.name === 'MRZ');
        return new MRZ(child);
    }
    /** The child document of type "Metadata". */
    get metadata() {
        const child = this.document.children.find((c) => c.type.name === 'Metadata');
        return new Metadata(child);
    }
}
BrIdCardBack.DOCUMENT_TYPE = 'BrIdCardBack';
BrIdCardBack.BARCODE_FIELD_NAME = 'Barcode';
BrIdCardBack.BARCODE_FIELD_NAME_NORMALIZED = 'BrIdCardBack.Barcode';
BrIdCardBack.BIRTH_DATE_FIELD_NAME = 'BirthDate';
BrIdCardBack.BIRTH_DATE_FIELD_NAME_NORMALIZED = 'BrIdCardBack.BirthDate';
BrIdCardBack.BIRTHPLACE_FIELD_NAME = 'Birthplace';
BrIdCardBack.BIRTHPLACE_FIELD_NAME_NORMALIZED = 'BrIdCardBack.Birthplace';
BrIdCardBack.CIVIL_REGISTRY_DETAILS_FIELD_NAME = 'CivilRegistryDetails';
BrIdCardBack.CIVIL_REGISTRY_DETAILS_FIELD_NAME_NORMALIZED = 'BrIdCardBack.CivilRegistryDetails';
BrIdCardBack.DRIVER_LICENSE_NUMBER_FIELD_NAME = 'DriverLicenseNumber';
BrIdCardBack.DRIVER_LICENSE_NUMBER_FIELD_NAME_NORMALIZED = 'BrIdCardBack.DriverLicenseNumber';
BrIdCardBack.EXPIRY_DATE_FIELD_NAME = 'ExpiryDate';
BrIdCardBack.EXPIRY_DATE_FIELD_NAME_NORMALIZED = 'BrIdCardBack.ExpiryDate';
BrIdCardBack.FINGERPRINT_FIELD_NAME = 'Fingerprint';
BrIdCardBack.FINGERPRINT_FIELD_NAME_NORMALIZED = 'BrIdCardBack.Fingerprint';
BrIdCardBack.GIVEN_NAMES_FIELD_NAME = 'GivenNames';
BrIdCardBack.GIVEN_NAMES_FIELD_NAME_NORMALIZED = 'BrIdCardBack.GivenNames';
BrIdCardBack.HEALTH_CARD_NUMBER_FIELD_NAME = 'HealthCardNumber';
BrIdCardBack.HEALTH_CARD_NUMBER_FIELD_NAME_NORMALIZED = 'BrIdCardBack.HealthCardNumber';
BrIdCardBack.ID_FIELD_NAME = 'ID';
BrIdCardBack.ID_FIELD_NAME_NORMALIZED = 'BrIdCardBack.ID';
BrIdCardBack.ISSUE_DATE_FIELD_NAME = 'IssueDate';
BrIdCardBack.ISSUE_DATE_FIELD_NAME_NORMALIZED = 'BrIdCardBack.IssueDate';
BrIdCardBack.ISSUING_AUTHORITY_FIELD_NAME = 'IssuingAuthority';
BrIdCardBack.ISSUING_AUTHORITY_FIELD_NAME_NORMALIZED = 'BrIdCardBack.IssuingAuthority';
BrIdCardBack.MILITARY_CERTIFICATE_NUMBER_FIELD_NAME = 'MilitaryCertificateNumber';
BrIdCardBack.MILITARY_CERTIFICATE_NUMBER_FIELD_NAME_NORMALIZED = 'BrIdCardBack.MilitaryCertificateNumber';
BrIdCardBack.PAGE_NUMBER_FIELD_NAME = 'PageNumber';
BrIdCardBack.PAGE_NUMBER_FIELD_NAME_NORMALIZED = 'BrIdCardBack.PageNumber';
BrIdCardBack.PARENTS_FIELD_NAME = 'Parents';
BrIdCardBack.PARENTS_FIELD_NAME_NORMALIZED = 'BrIdCardBack.Parents';
BrIdCardBack.PERSONAL_NUMBER_FIELD_NAME = 'PersonalNumber';
BrIdCardBack.PERSONAL_NUMBER_FIELD_NAME_NORMALIZED = 'BrIdCardBack.PersonalNumber';
BrIdCardBack.PHOTO_FIELD_NAME = 'Photo';
BrIdCardBack.PHOTO_FIELD_NAME_NORMALIZED = 'BrIdCardBack.Photo';
BrIdCardBack.PLACE_OF_ISSUE_FIELD_NAME = 'PlaceOfIssue';
BrIdCardBack.PLACE_OF_ISSUE_FIELD_NAME_NORMALIZED = 'BrIdCardBack.PlaceOfIssue';
BrIdCardBack.PLACE_OF_ORIGIN_FIELD_NAME = 'PlaceOfOrigin';
BrIdCardBack.PLACE_OF_ORIGIN_FIELD_NAME_NORMALIZED = 'BrIdCardBack.PlaceOfOrigin';
BrIdCardBack.PROFESSIONAL_IDENTITY_NUMBER_FIELD_NAME = 'ProfessionalIdentityNumber';
BrIdCardBack.PROFESSIONAL_IDENTITY_NUMBER_FIELD_NAME_NORMALIZED = 'BrIdCardBack.ProfessionalIdentityNumber';
BrIdCardBack.RAW_MRZ_FIELD_NAME = 'RawMRZ';
BrIdCardBack.RAW_MRZ_FIELD_NAME_NORMALIZED = 'BrIdCardBack.RawMRZ';
BrIdCardBack.SIGNATURE_FIELD_NAME = 'Signature';
BrIdCardBack.SIGNATURE_FIELD_NAME_NORMALIZED = 'BrIdCardBack.Signature';
BrIdCardBack.SOCIAL_SECURITY_NUMBER_FIELD_NAME = 'SocialSecurityNumber';
BrIdCardBack.SOCIAL_SECURITY_NUMBER_FIELD_NAME_NORMALIZED = 'BrIdCardBack.SocialSecurityNumber';
BrIdCardBack.STATE_CODE_FIELD_NAME = 'StateCode';
BrIdCardBack.STATE_CODE_FIELD_NAME_NORMALIZED = 'BrIdCardBack.StateCode';
BrIdCardBack.TAXPAYER_NUMBER_FIELD_NAME = 'TaxpayerNumber';
BrIdCardBack.TAXPAYER_NUMBER_FIELD_NAME_NORMALIZED = 'BrIdCardBack.TaxpayerNumber';
BrIdCardBack.VOTER_REGISTRATION_NUMBER_FIELD_NAME = 'VoterRegistrationNumber';
BrIdCardBack.VOTER_REGISTRATION_NUMBER_FIELD_NAME_NORMALIZED = 'BrIdCardBack.VoterRegistrationNumber';
BrIdCardBack.WORK_CARD_NUMBER_FIELD_NAME = 'WorkCardNumber';
BrIdCardBack.WORK_CARD_NUMBER_FIELD_NAME_NORMALIZED = 'BrIdCardBack.WorkCardNumber';
BrIdCardBack.WORK_CARD_SERIES_FIELD_NAME = 'WorkCardSeries';
BrIdCardBack.WORK_CARD_SERIES_FIELD_NAME_NORMALIZED = 'BrIdCardBack.WorkCardSeries';
/** BrIdCardFrontPhotoOnly */
export class BrIdCardFrontPhotoOnly {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return BrIdCardFrontPhotoOnly.DOCUMENT_TYPE;
    }
    /** Fingerprint */
    get fingerprint() {
        return this.document.fields.find((f) => f.type.name === 'Fingerprint');
    }
    /** Photo */
    get photo() {
        return this.document.fields.find((f) => f.type.name === 'Photo');
    }
    /** The child document of type "Metadata". */
    get metadata() {
        const child = this.document.children.find((c) => c.type.name === 'Metadata');
        return new Metadata(child);
    }
}
BrIdCardFrontPhotoOnly.DOCUMENT_TYPE = 'BrIdCardFrontPhotoOnly';
BrIdCardFrontPhotoOnly.FINGERPRINT_FIELD_NAME = 'Fingerprint';
BrIdCardFrontPhotoOnly.FINGERPRINT_FIELD_NAME_NORMALIZED = 'BrIdCardFrontPhotoOnly.Fingerprint';
BrIdCardFrontPhotoOnly.PHOTO_FIELD_NAME = 'Photo';
BrIdCardFrontPhotoOnly.PHOTO_FIELD_NAME_NORMALIZED = 'BrIdCardFrontPhotoOnly.Photo';
/** CnEntryAndExitPermitBack */
export class CnEntryAndExitPermitBack {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return CnEntryAndExitPermitBack.DOCUMENT_TYPE;
    }
    /** Barcode on the bottom of the document */
    get barcodeBottom() {
        return this.document.fields.find((f) => f.type.name === 'BarcodeBottom');
    }
    /** Barcode on the top of the document */
    get barcodeTop() {
        return this.document.fields.find((f) => f.type.name === 'BarcodeTop');
    }
    /** Hong Kong Valid From Date */
    get hongKongValidFrom() {
        return this.document.fields.find((f) => f.type.name === 'HongKongValidFrom');
    }
    /** Hong Kong Valid Until Date */
    get hongKongValidUntil() {
        return this.document.fields.find((f) => f.type.name === 'HongKongValidUntil');
    }
    /** Macao Valid From Date */
    get macaoValidFrom() {
        return this.document.fields.find((f) => f.type.name === 'MacaoValidFrom');
    }
    /** Macao Valid Until Date */
    get macaoValidUntil() {
        return this.document.fields.find((f) => f.type.name === 'MacaoValidUntil');
    }
    /** Raw MRZ text value */
    get rawMRZ() {
        return this.document.fields.find((f) => f.type.name === 'RawMRZ');
    }
    /** Taiwan Identification Number */
    get taiwanIDNumber() {
        return this.document.fields.find((f) => f.type.name === 'TaiwanIDNumber');
    }
    /** The child document of type "MRZ". */
    get mrz() {
        const child = this.document.children.find((c) => c.type.name === 'MRZ');
        return new MRZ(child);
    }
    /** The child document of type "Metadata". */
    get metadata() {
        const child = this.document.children.find((c) => c.type.name === 'Metadata');
        return new Metadata(child);
    }
}
CnEntryAndExitPermitBack.DOCUMENT_TYPE = 'CnEntryAndExitPermitBack';
CnEntryAndExitPermitBack.BARCODE_BOTTOM_FIELD_NAME = 'BarcodeBottom';
CnEntryAndExitPermitBack.BARCODE_BOTTOM_FIELD_NAME_NORMALIZED = 'CnEntryAndExitPermitBack.BarcodeBottom';
CnEntryAndExitPermitBack.BARCODE_TOP_FIELD_NAME = 'BarcodeTop';
CnEntryAndExitPermitBack.BARCODE_TOP_FIELD_NAME_NORMALIZED = 'CnEntryAndExitPermitBack.BarcodeTop';
CnEntryAndExitPermitBack.HONG_KONG_VALID_FROM_FIELD_NAME = 'HongKongValidFrom';
CnEntryAndExitPermitBack.HONG_KONG_VALID_FROM_FIELD_NAME_NORMALIZED = 'CnEntryAndExitPermitBack.HongKongValidFrom';
CnEntryAndExitPermitBack.HONG_KONG_VALID_UNTIL_FIELD_NAME = 'HongKongValidUntil';
CnEntryAndExitPermitBack.HONG_KONG_VALID_UNTIL_FIELD_NAME_NORMALIZED = 'CnEntryAndExitPermitBack.HongKongValidUntil';
CnEntryAndExitPermitBack.MACAO_VALID_FROM_FIELD_NAME = 'MacaoValidFrom';
CnEntryAndExitPermitBack.MACAO_VALID_FROM_FIELD_NAME_NORMALIZED = 'CnEntryAndExitPermitBack.MacaoValidFrom';
CnEntryAndExitPermitBack.MACAO_VALID_UNTIL_FIELD_NAME = 'MacaoValidUntil';
CnEntryAndExitPermitBack.MACAO_VALID_UNTIL_FIELD_NAME_NORMALIZED = 'CnEntryAndExitPermitBack.MacaoValidUntil';
CnEntryAndExitPermitBack.RAW_MRZ_FIELD_NAME = 'RawMRZ';
CnEntryAndExitPermitBack.RAW_MRZ_FIELD_NAME_NORMALIZED = 'CnEntryAndExitPermitBack.RawMRZ';
CnEntryAndExitPermitBack.TAIWAN_ID_NUMBER_FIELD_NAME = 'TaiwanIDNumber';
CnEntryAndExitPermitBack.TAIWAN_ID_NUMBER_FIELD_NAME_NORMALIZED = 'CnEntryAndExitPermitBack.TaiwanIDNumber';
/** CnEntryAndExitPermitFront */
export class CnEntryAndExitPermitFront {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return CnEntryAndExitPermitFront.DOCUMENT_TYPE;
    }
    /** Date of Birth */
    get birthDate() {
        return this.document.fields.find((f) => f.type.name === 'BirthDate');
    }
    /** Business Type */
    get business() {
        return this.document.fields.find((f) => f.type.name === 'Business');
    }
    /** Destinations */
    get destinations() {
        return this.document.fields.find((f) => f.type.name === 'Destinations');
    }
    /** Gender */
    get gender() {
        return this.document.fields.find((f) => f.type.name === 'Gender');
    }
    /** Given Names */
    get givenNames() {
        return this.document.fields.find((f) => f.type.name === 'GivenNames');
    }
    /** Identity Document Number */
    get id() {
        return this.document.fields.find((f) => f.type.name === 'ID');
    }
    /** Date when the permit was issued */
    get issueDate() {
        return this.document.fields.find((f) => f.type.name === 'IssueDate');
    }
    /** MRZ text value */
    get mrzLine() {
        return this.document.fields.find((f) => f.type.name === 'MRZLine');
    }
    /** Photo */
    get photo() {
        return this.document.fields.find((f) => f.type.name === 'Photo');
    }
    /** Place where the permit was issued */
    get placeOfIssue() {
        return this.document.fields.find((f) => f.type.name === 'PlaceOfIssue');
    }
    /** Ports where the cardholder can enter or exit */
    get portsOfExitAndEntry() {
        return this.document.fields.find((f) => f.type.name === 'PortsOfExitAndEntry');
    }
    /** Raw MRZ text value */
    get rawMRZ() {
        return this.document.fields.find((f) => f.type.name === 'RawMRZ');
    }
    /** Number of times the cardholder has exited or entered */
    get timesOfExitAndEntry() {
        return this.document.fields.find((f) => f.type.name === 'TimesOfExitAndEntry');
    }
    /** Start date of the permit validity */
    get validFrom() {
        return this.document.fields.find((f) => f.type.name === 'ValidFrom');
    }
    /** End date of the permit validity */
    get validUntil() {
        return this.document.fields.find((f) => f.type.name === 'ValidUntil');
    }
    /** The child document of type "MRZ". */
    get mrz() {
        const child = this.document.children.find((c) => c.type.name === 'MRZ');
        return new MRZ(child);
    }
    /** The child document of type "Metadata". */
    get metadata() {
        const child = this.document.children.find((c) => c.type.name === 'Metadata');
        return new Metadata(child);
    }
}
CnEntryAndExitPermitFront.DOCUMENT_TYPE = 'CnEntryAndExitPermitFront';
CnEntryAndExitPermitFront.BIRTH_DATE_FIELD_NAME = 'BirthDate';
CnEntryAndExitPermitFront.BIRTH_DATE_FIELD_NAME_NORMALIZED = 'CnEntryAndExitPermitFront.BirthDate';
CnEntryAndExitPermitFront.BUSINESS_FIELD_NAME = 'Business';
CnEntryAndExitPermitFront.BUSINESS_FIELD_NAME_NORMALIZED = 'CnEntryAndExitPermitFront.Business';
CnEntryAndExitPermitFront.DESTINATIONS_FIELD_NAME = 'Destinations';
CnEntryAndExitPermitFront.DESTINATIONS_FIELD_NAME_NORMALIZED = 'CnEntryAndExitPermitFront.Destinations';
CnEntryAndExitPermitFront.GENDER_FIELD_NAME = 'Gender';
CnEntryAndExitPermitFront.GENDER_FIELD_NAME_NORMALIZED = 'CnEntryAndExitPermitFront.Gender';
CnEntryAndExitPermitFront.GIVEN_NAMES_FIELD_NAME = 'GivenNames';
CnEntryAndExitPermitFront.GIVEN_NAMES_FIELD_NAME_NORMALIZED = 'CnEntryAndExitPermitFront.GivenNames';
CnEntryAndExitPermitFront.ID_FIELD_NAME = 'ID';
CnEntryAndExitPermitFront.ID_FIELD_NAME_NORMALIZED = 'CnEntryAndExitPermitFront.ID';
CnEntryAndExitPermitFront.ISSUE_DATE_FIELD_NAME = 'IssueDate';
CnEntryAndExitPermitFront.ISSUE_DATE_FIELD_NAME_NORMALIZED = 'CnEntryAndExitPermitFront.IssueDate';
CnEntryAndExitPermitFront.MRZ_LINE_FIELD_NAME = 'MRZLine';
CnEntryAndExitPermitFront.MRZ_LINE_FIELD_NAME_NORMALIZED = 'CnEntryAndExitPermitFront.MRZLine';
CnEntryAndExitPermitFront.PHOTO_FIELD_NAME = 'Photo';
CnEntryAndExitPermitFront.PHOTO_FIELD_NAME_NORMALIZED = 'CnEntryAndExitPermitFront.Photo';
CnEntryAndExitPermitFront.PLACE_OF_ISSUE_FIELD_NAME = 'PlaceOfIssue';
CnEntryAndExitPermitFront.PLACE_OF_ISSUE_FIELD_NAME_NORMALIZED = 'CnEntryAndExitPermitFront.PlaceOfIssue';
CnEntryAndExitPermitFront.PORTS_OF_EXIT_AND_ENTRY_FIELD_NAME = 'PortsOfExitAndEntry';
CnEntryAndExitPermitFront.PORTS_OF_EXIT_AND_ENTRY_FIELD_NAME_NORMALIZED = 'CnEntryAndExitPermitFront.PortsOfExitAndEntry';
CnEntryAndExitPermitFront.RAW_MRZ_FIELD_NAME = 'RawMRZ';
CnEntryAndExitPermitFront.RAW_MRZ_FIELD_NAME_NORMALIZED = 'CnEntryAndExitPermitFront.RawMRZ';
CnEntryAndExitPermitFront.TIMES_OF_EXIT_AND_ENTRY_FIELD_NAME = 'TimesOfExitAndEntry';
CnEntryAndExitPermitFront.TIMES_OF_EXIT_AND_ENTRY_FIELD_NAME_NORMALIZED = 'CnEntryAndExitPermitFront.TimesOfExitAndEntry';
CnEntryAndExitPermitFront.VALID_FROM_FIELD_NAME = 'ValidFrom';
CnEntryAndExitPermitFront.VALID_FROM_FIELD_NAME_NORMALIZED = 'CnEntryAndExitPermitFront.ValidFrom';
CnEntryAndExitPermitFront.VALID_UNTIL_FIELD_NAME = 'ValidUntil';
CnEntryAndExitPermitFront.VALID_UNTIL_FIELD_NAME_NORMALIZED = 'CnEntryAndExitPermitFront.ValidUntil';
/** CnPermanentResidentCardFront */
export class CnPermanentResidentCardFront {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return CnPermanentResidentCardFront.DOCUMENT_TYPE;
    }
    /** Date of Birth */
    get birthDate() {
        return this.document.fields.find((f) => f.type.name === 'BirthDate');
    }
    /** Gender */
    get gender() {
        return this.document.fields.find((f) => f.type.name === 'Gender');
    }
    /** Given Names */
    get givenNames() {
        return this.document.fields.find((f) => f.type.name === 'GivenNames');
    }
    /** Identity Document Number */
    get id() {
        return this.document.fields.find((f) => f.type.name === 'ID');
    }
    /** Authority issuing the card */
    get issuingAuthority() {
        return this.document.fields.find((f) => f.type.name === 'IssuingAuthority');
    }
    /** Nationality */
    get nationality() {
        return this.document.fields.find((f) => f.type.name === 'Nationality');
    }
    /** Photo */
    get photo() {
        return this.document.fields.find((f) => f.type.name === 'Photo');
    }
    /** Start date of the validity of the card */
    get validFrom() {
        return this.document.fields.find((f) => f.type.name === 'ValidFrom');
    }
    /** End date of the validity of the card */
    get validUntil() {
        return this.document.fields.find((f) => f.type.name === 'ValidUntil');
    }
    /** The child document of type "Metadata". */
    get metadata() {
        const child = this.document.children.find((c) => c.type.name === 'Metadata');
        return new Metadata(child);
    }
}
CnPermanentResidentCardFront.DOCUMENT_TYPE = 'CnPermanentResidentCardFront';
CnPermanentResidentCardFront.BIRTH_DATE_FIELD_NAME = 'BirthDate';
CnPermanentResidentCardFront.BIRTH_DATE_FIELD_NAME_NORMALIZED = 'CnPermanentResidentCardFront.BirthDate';
CnPermanentResidentCardFront.GENDER_FIELD_NAME = 'Gender';
CnPermanentResidentCardFront.GENDER_FIELD_NAME_NORMALIZED = 'CnPermanentResidentCardFront.Gender';
CnPermanentResidentCardFront.GIVEN_NAMES_FIELD_NAME = 'GivenNames';
CnPermanentResidentCardFront.GIVEN_NAMES_FIELD_NAME_NORMALIZED = 'CnPermanentResidentCardFront.GivenNames';
CnPermanentResidentCardFront.ID_FIELD_NAME = 'ID';
CnPermanentResidentCardFront.ID_FIELD_NAME_NORMALIZED = 'CnPermanentResidentCardFront.ID';
CnPermanentResidentCardFront.ISSUING_AUTHORITY_FIELD_NAME = 'IssuingAuthority';
CnPermanentResidentCardFront.ISSUING_AUTHORITY_FIELD_NAME_NORMALIZED = 'CnPermanentResidentCardFront.IssuingAuthority';
CnPermanentResidentCardFront.NATIONALITY_FIELD_NAME = 'Nationality';
CnPermanentResidentCardFront.NATIONALITY_FIELD_NAME_NORMALIZED = 'CnPermanentResidentCardFront.Nationality';
CnPermanentResidentCardFront.PHOTO_FIELD_NAME = 'Photo';
CnPermanentResidentCardFront.PHOTO_FIELD_NAME_NORMALIZED = 'CnPermanentResidentCardFront.Photo';
CnPermanentResidentCardFront.VALID_FROM_FIELD_NAME = 'ValidFrom';
CnPermanentResidentCardFront.VALID_FROM_FIELD_NAME_NORMALIZED = 'CnPermanentResidentCardFront.ValidFrom';
CnPermanentResidentCardFront.VALID_UNTIL_FIELD_NAME = 'ValidUntil';
CnPermanentResidentCardFront.VALID_UNTIL_FIELD_NAME_NORMALIZED = 'CnPermanentResidentCardFront.ValidUntil';
/** HkIdentityCardFront */
export class HkIdentityCardFront {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return HkIdentityCardFront.DOCUMENT_TYPE;
    }
    /** Date of Birth */
    get birthDate() {
        return this.document.fields.find((f) => f.type.name === 'BirthDate');
    }
    /** Gender */
    get gender() {
        return this.document.fields.find((f) => f.type.name === 'Gender');
    }
    /** Given Names */
    get givenNames() {
        return this.document.fields.find((f) => f.type.name === 'GivenNames');
    }
    /** Given Names represented in Chinese code */
    get givenNamesInChineseCode() {
        return this.document.fields.find((f) => f.type.name === 'GivenNamesInChineseCode');
    }
    /** Identity Document Number */
    get id() {
        return this.document.fields.find((f) => f.type.name === 'ID');
    }
    /** ID Symbols */
    get idSymbols() {
        return this.document.fields.find((f) => f.type.name === 'IDSymbols');
    }
    /** Date when the cardholder was initially registered */
    get initialRegistrationDate() {
        return this.document.fields.find((f) => f.type.name === 'InitialRegistrationDate');
    }
    /** Date when the identity card was issued */
    get issueDate() {
        return this.document.fields.find((f) => f.type.name === 'IssueDate');
    }
    /** Photo */
    get photo() {
        return this.document.fields.find((f) => f.type.name === 'Photo');
    }
    /** The child document of type "Metadata". */
    get metadata() {
        const child = this.document.children.find((c) => c.type.name === 'Metadata');
        return new Metadata(child);
    }
}
HkIdentityCardFront.DOCUMENT_TYPE = 'HkIdentityCardFront';
HkIdentityCardFront.BIRTH_DATE_FIELD_NAME = 'BirthDate';
HkIdentityCardFront.BIRTH_DATE_FIELD_NAME_NORMALIZED = 'HkIdentityCardFront.BirthDate';
HkIdentityCardFront.GENDER_FIELD_NAME = 'Gender';
HkIdentityCardFront.GENDER_FIELD_NAME_NORMALIZED = 'HkIdentityCardFront.Gender';
HkIdentityCardFront.GIVEN_NAMES_FIELD_NAME = 'GivenNames';
HkIdentityCardFront.GIVEN_NAMES_FIELD_NAME_NORMALIZED = 'HkIdentityCardFront.GivenNames';
HkIdentityCardFront.GIVEN_NAMES_IN_CHINESE_CODE_FIELD_NAME = 'GivenNamesInChineseCode';
HkIdentityCardFront.GIVEN_NAMES_IN_CHINESE_CODE_FIELD_NAME_NORMALIZED = 'HkIdentityCardFront.GivenNamesInChineseCode';
HkIdentityCardFront.ID_FIELD_NAME = 'ID';
HkIdentityCardFront.ID_FIELD_NAME_NORMALIZED = 'HkIdentityCardFront.ID';
HkIdentityCardFront.ID_SYMBOLS_FIELD_NAME = 'IDSymbols';
HkIdentityCardFront.ID_SYMBOLS_FIELD_NAME_NORMALIZED = 'HkIdentityCardFront.IDSymbols';
HkIdentityCardFront.INITIAL_REGISTRATION_DATE_FIELD_NAME = 'InitialRegistrationDate';
HkIdentityCardFront.INITIAL_REGISTRATION_DATE_FIELD_NAME_NORMALIZED = 'HkIdentityCardFront.InitialRegistrationDate';
HkIdentityCardFront.ISSUE_DATE_FIELD_NAME = 'IssueDate';
HkIdentityCardFront.ISSUE_DATE_FIELD_NAME_NORMALIZED = 'HkIdentityCardFront.IssueDate';
HkIdentityCardFront.PHOTO_FIELD_NAME = 'Photo';
HkIdentityCardFront.PHOTO_FIELD_NAME_NORMALIZED = 'HkIdentityCardFront.Photo';
/** TwEntryAndExitPermit */
export class TwEntryAndExitPermit {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return TwEntryAndExitPermit.DOCUMENT_TYPE;
    }
    /** Barcode on the left of the document */
    get barcodeLeft() {
        return this.document.fields.find((f) => f.type.name === 'BarcodeLeft');
    }
    /** Barcode on the right of the document */
    get barcodeRight() {
        return this.document.fields.find((f) => f.type.name === 'BarcodeRight');
    }
    /** Date of Birth */
    get birthDate() {
        return this.document.fields.find((f) => f.type.name === 'BirthDate');
    }
    /** Country Code */
    get countryCode() {
        return this.document.fields.find((f) => f.type.name === 'CountryCode');
    }
    /** Country of Residency */
    get countryOfResidency() {
        return this.document.fields.find((f) => f.type.name === 'CountryOfResidency');
    }
    /** Document Type */
    get documentType() {
        return this.document.fields.find((f) => f.type.name === 'DocumentType');
    }
    /** Entry inspection information */
    get entryInspection() {
        return this.document.fields.find((f) => f.type.name === 'EntryInspection');
    }
    /** Exit inspection information */
    get exitInspection() {
        return this.document.fields.find((f) => f.type.name === 'ExitInspection');
    }
    /** Expiry Date of the permit */
    get expiryDate() {
        return this.document.fields.find((f) => f.type.name === 'ExpiryDate');
    }
    /** Gender */
    get gender() {
        return this.document.fields.find((f) => f.type.name === 'Gender');
    }
    /** Given Names */
    get givenNames() {
        return this.document.fields.find((f) => f.type.name === 'GivenNames');
    }
    /** Identity Document Number */
    get id() {
        return this.document.fields.find((f) => f.type.name === 'ID');
    }
    /** Date when the permit was issued */
    get issueDate() {
        return this.document.fields.find((f) => f.type.name === 'IssueDate');
    }
    /** Passport Number */
    get passportNumber() {
        return this.document.fields.find((f) => f.type.name === 'PassportNumber');
    }
    /** Personal number */
    get personalNumber() {
        return this.document.fields.find((f) => f.type.name === 'PersonalNumber');
    }
    /** Photograph */
    get photo() {
        return this.document.fields.find((f) => f.type.name === 'Photo');
    }
    /** Raw MRZ text value */
    get rawMRZ() {
        return this.document.fields.find((f) => f.type.name === 'RawMRZ');
    }
    /** Remarks section of the permit */
    get remarks() {
        return this.document.fields.find((f) => f.type.name === 'Remarks');
    }
    /** The child document of type "MRZ". */
    get mrz() {
        const child = this.document.children.find((c) => c.type.name === 'MRZ');
        return new MRZ(child);
    }
    /** The child document of type "Metadata". */
    get metadata() {
        const child = this.document.children.find((c) => c.type.name === 'Metadata');
        return new Metadata(child);
    }
}
TwEntryAndExitPermit.DOCUMENT_TYPE = 'TwEntryAndExitPermit';
TwEntryAndExitPermit.BARCODE_LEFT_FIELD_NAME = 'BarcodeLeft';
TwEntryAndExitPermit.BARCODE_LEFT_FIELD_NAME_NORMALIZED = 'TwEntryAndExitPermit.BarcodeLeft';
TwEntryAndExitPermit.BARCODE_RIGHT_FIELD_NAME = 'BarcodeRight';
TwEntryAndExitPermit.BARCODE_RIGHT_FIELD_NAME_NORMALIZED = 'TwEntryAndExitPermit.BarcodeRight';
TwEntryAndExitPermit.BIRTH_DATE_FIELD_NAME = 'BirthDate';
TwEntryAndExitPermit.BIRTH_DATE_FIELD_NAME_NORMALIZED = 'TwEntryAndExitPermit.BirthDate';
TwEntryAndExitPermit.COUNTRY_CODE_FIELD_NAME = 'CountryCode';
TwEntryAndExitPermit.COUNTRY_CODE_FIELD_NAME_NORMALIZED = 'TwEntryAndExitPermit.CountryCode';
TwEntryAndExitPermit.COUNTRY_OF_RESIDENCY_FIELD_NAME = 'CountryOfResidency';
TwEntryAndExitPermit.COUNTRY_OF_RESIDENCY_FIELD_NAME_NORMALIZED = 'TwEntryAndExitPermit.CountryOfResidency';
TwEntryAndExitPermit.DOCUMENT_TYPE_FIELD_NAME = 'DocumentType';
TwEntryAndExitPermit.DOCUMENT_TYPE_FIELD_NAME_NORMALIZED = 'TwEntryAndExitPermit.DocumentType';
TwEntryAndExitPermit.ENTRY_INSPECTION_FIELD_NAME = 'EntryInspection';
TwEntryAndExitPermit.ENTRY_INSPECTION_FIELD_NAME_NORMALIZED = 'TwEntryAndExitPermit.EntryInspection';
TwEntryAndExitPermit.EXIT_INSPECTION_FIELD_NAME = 'ExitInspection';
TwEntryAndExitPermit.EXIT_INSPECTION_FIELD_NAME_NORMALIZED = 'TwEntryAndExitPermit.ExitInspection';
TwEntryAndExitPermit.EXPIRY_DATE_FIELD_NAME = 'ExpiryDate';
TwEntryAndExitPermit.EXPIRY_DATE_FIELD_NAME_NORMALIZED = 'TwEntryAndExitPermit.ExpiryDate';
TwEntryAndExitPermit.GENDER_FIELD_NAME = 'Gender';
TwEntryAndExitPermit.GENDER_FIELD_NAME_NORMALIZED = 'TwEntryAndExitPermit.Gender';
TwEntryAndExitPermit.GIVEN_NAMES_FIELD_NAME = 'GivenNames';
TwEntryAndExitPermit.GIVEN_NAMES_FIELD_NAME_NORMALIZED = 'TwEntryAndExitPermit.GivenNames';
TwEntryAndExitPermit.ID_FIELD_NAME = 'ID';
TwEntryAndExitPermit.ID_FIELD_NAME_NORMALIZED = 'TwEntryAndExitPermit.ID';
TwEntryAndExitPermit.ISSUE_DATE_FIELD_NAME = 'IssueDate';
TwEntryAndExitPermit.ISSUE_DATE_FIELD_NAME_NORMALIZED = 'TwEntryAndExitPermit.IssueDate';
TwEntryAndExitPermit.PASSPORT_NUMBER_FIELD_NAME = 'PassportNumber';
TwEntryAndExitPermit.PASSPORT_NUMBER_FIELD_NAME_NORMALIZED = 'TwEntryAndExitPermit.PassportNumber';
TwEntryAndExitPermit.PERSONAL_NUMBER_FIELD_NAME = 'PersonalNumber';
TwEntryAndExitPermit.PERSONAL_NUMBER_FIELD_NAME_NORMALIZED = 'TwEntryAndExitPermit.PersonalNumber';
TwEntryAndExitPermit.PHOTO_FIELD_NAME = 'Photo';
TwEntryAndExitPermit.PHOTO_FIELD_NAME_NORMALIZED = 'TwEntryAndExitPermit.Photo';
TwEntryAndExitPermit.RAW_MRZ_FIELD_NAME = 'RawMRZ';
TwEntryAndExitPermit.RAW_MRZ_FIELD_NAME_NORMALIZED = 'TwEntryAndExitPermit.RawMRZ';
TwEntryAndExitPermit.REMARKS_FIELD_NAME = 'Remarks';
TwEntryAndExitPermit.REMARKS_FIELD_NAME_NORMALIZED = 'TwEntryAndExitPermit.Remarks';
/** MoIdentityCardBack */
export class MoIdentityCardBack {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return MoIdentityCardBack.DOCUMENT_TYPE;
    }
    /** Raw MRZ text value */
    get rawMRZ() {
        return this.document.fields.find((f) => f.type.name === 'RawMRZ');
    }
    /** Validation Photo */
    get validationPhoto() {
        return this.document.fields.find((f) => f.type.name === 'ValidationPhoto');
    }
    /** The child document of type "MRZ". */
    get mrz() {
        const child = this.document.children.find((c) => c.type.name === 'MRZ');
        return new MRZ(child);
    }
    /** The child document of type "Metadata". */
    get metadata() {
        const child = this.document.children.find((c) => c.type.name === 'Metadata');
        return new Metadata(child);
    }
}
MoIdentityCardBack.DOCUMENT_TYPE = 'MoIdentityCardBack';
MoIdentityCardBack.RAW_MRZ_FIELD_NAME = 'RawMRZ';
MoIdentityCardBack.RAW_MRZ_FIELD_NAME_NORMALIZED = 'MoIdentityCardBack.RawMRZ';
MoIdentityCardBack.VALIDATION_PHOTO_FIELD_NAME = 'ValidationPhoto';
MoIdentityCardBack.VALIDATION_PHOTO_FIELD_NAME_NORMALIZED = 'MoIdentityCardBack.ValidationPhoto';
/** MoIdentityCardFront */
export class MoIdentityCardFront {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return MoIdentityCardFront.DOCUMENT_TYPE;
    }
    /** Date of Birth */
    get birthDate() {
        return this.document.fields.find((f) => f.type.name === 'BirthDate');
    }
    /** Gender */
    get gender() {
        return this.document.fields.find((f) => f.type.name === 'Gender');
    }
    /** Given Names */
    get givenNames() {
        return this.document.fields.find((f) => f.type.name === 'GivenNames');
    }
    /** Identity Document Number */
    get id() {
        return this.document.fields.find((f) => f.type.name === 'ID');
    }
    /** Photo */
    get photo() {
        return this.document.fields.find((f) => f.type.name === 'Photo');
    }
    /** Signature */
    get signature() {
        return this.document.fields.find((f) => f.type.name === 'Signature');
    }
    /** Surname */
    get surname() {
        return this.document.fields.find((f) => f.type.name === 'Surname');
    }
    /** Start date of the card validity */
    get validFrom() {
        return this.document.fields.find((f) => f.type.name === 'ValidFrom');
    }
    /** End date of the card validity */
    get validUntil() {
        return this.document.fields.find((f) => f.type.name === 'ValidUntil');
    }
    /** Validation photo */
    get validationPhoto() {
        return this.document.fields.find((f) => f.type.name === 'ValidationPhoto');
    }
    /** The child document of type "Metadata". */
    get metadata() {
        const child = this.document.children.find((c) => c.type.name === 'Metadata');
        return new Metadata(child);
    }
}
MoIdentityCardFront.DOCUMENT_TYPE = 'MoIdentityCardFront';
MoIdentityCardFront.BIRTH_DATE_FIELD_NAME = 'BirthDate';
MoIdentityCardFront.BIRTH_DATE_FIELD_NAME_NORMALIZED = 'MoIdentityCardFront.BirthDate';
MoIdentityCardFront.GENDER_FIELD_NAME = 'Gender';
MoIdentityCardFront.GENDER_FIELD_NAME_NORMALIZED = 'MoIdentityCardFront.Gender';
MoIdentityCardFront.GIVEN_NAMES_FIELD_NAME = 'GivenNames';
MoIdentityCardFront.GIVEN_NAMES_FIELD_NAME_NORMALIZED = 'MoIdentityCardFront.GivenNames';
MoIdentityCardFront.ID_FIELD_NAME = 'ID';
MoIdentityCardFront.ID_FIELD_NAME_NORMALIZED = 'MoIdentityCardFront.ID';
MoIdentityCardFront.PHOTO_FIELD_NAME = 'Photo';
MoIdentityCardFront.PHOTO_FIELD_NAME_NORMALIZED = 'MoIdentityCardFront.Photo';
MoIdentityCardFront.SIGNATURE_FIELD_NAME = 'Signature';
MoIdentityCardFront.SIGNATURE_FIELD_NAME_NORMALIZED = 'MoIdentityCardFront.Signature';
MoIdentityCardFront.SURNAME_FIELD_NAME = 'Surname';
MoIdentityCardFront.SURNAME_FIELD_NAME_NORMALIZED = 'MoIdentityCardFront.Surname';
MoIdentityCardFront.VALID_FROM_FIELD_NAME = 'ValidFrom';
MoIdentityCardFront.VALID_FROM_FIELD_NAME_NORMALIZED = 'MoIdentityCardFront.ValidFrom';
MoIdentityCardFront.VALID_UNTIL_FIELD_NAME = 'ValidUntil';
MoIdentityCardFront.VALID_UNTIL_FIELD_NAME_NORMALIZED = 'MoIdentityCardFront.ValidUntil';
MoIdentityCardFront.VALIDATION_PHOTO_FIELD_NAME = 'ValidationPhoto';
MoIdentityCardFront.VALIDATION_PHOTO_FIELD_NAME_NORMALIZED = 'MoIdentityCardFront.ValidationPhoto';
/** RoIdCardTD3 */
export class RoIdCardTD3 {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return RoIdCardTD3.DOCUMENT_TYPE;
    }
    /** Address */
    get address() {
        return this.document.fields.find((f) => f.type.name === 'Address');
    }
    /** Birthplace */
    get birthplace() {
        return this.document.fields.find((f) => f.type.name === 'Birthplace');
    }
    /** Expiry date */
    get expiryDate() {
        return this.document.fields.find((f) => f.type.name === 'ExpiryDate');
    }
    /** Gender */
    get gender() {
        return this.document.fields.find((f) => f.type.name === 'Gender');
    }
    /** Given Names */
    get givenNames() {
        return this.document.fields.find((f) => f.type.name === 'GivenNames');
    }
    /** Series and number of the ID card */
    get id() {
        return this.document.fields.find((f) => f.type.name === 'ID');
    }
    /** Issuing authority */
    get issuingAuthority() {
        return this.document.fields.find((f) => f.type.name === 'IssuingAuthority');
    }
    /** Nationality */
    get nationality() {
        return this.document.fields.find((f) => f.type.name === 'Nationality');
    }
    /** Personal Number (CNP) */
    get personalNumber() {
        return this.document.fields.find((f) => f.type.name === 'PersonalNumber');
    }
    /** Photo image */
    get photo() {
        return this.document.fields.find((f) => f.type.name === 'Photo');
    }
    /** Raw MRZ text value */
    get rawMRZ() {
        return this.document.fields.find((f) => f.type.name === 'RawMRZ');
    }
    /** Surname */
    get surname() {
        return this.document.fields.find((f) => f.type.name === 'Surname');
    }
    /** Valid from date */
    get validFromDate() {
        return this.document.fields.find((f) => f.type.name === 'ValidFromDate');
    }
    /** The child document of type "MRZ". */
    get mrz() {
        const child = this.document.children.find((c) => c.type.name === 'MRZ');
        return new MRZ(child);
    }
    /** The child document of type "Metadata". */
    get metadata() {
        const child = this.document.children.find((c) => c.type.name === 'Metadata');
        return new Metadata(child);
    }
}
RoIdCardTD3.DOCUMENT_TYPE = 'RoIdCardTD3';
RoIdCardTD3.ADDRESS_FIELD_NAME = 'Address';
RoIdCardTD3.ADDRESS_FIELD_NAME_NORMALIZED = 'RoIdCardTD3.Address';
RoIdCardTD3.BIRTHPLACE_FIELD_NAME = 'Birthplace';
RoIdCardTD3.BIRTHPLACE_FIELD_NAME_NORMALIZED = 'RoIdCardTD3.Birthplace';
RoIdCardTD3.EXPIRY_DATE_FIELD_NAME = 'ExpiryDate';
RoIdCardTD3.EXPIRY_DATE_FIELD_NAME_NORMALIZED = 'RoIdCardTD3.ExpiryDate';
RoIdCardTD3.GENDER_FIELD_NAME = 'Gender';
RoIdCardTD3.GENDER_FIELD_NAME_NORMALIZED = 'RoIdCardTD3.Gender';
RoIdCardTD3.GIVEN_NAMES_FIELD_NAME = 'GivenNames';
RoIdCardTD3.GIVEN_NAMES_FIELD_NAME_NORMALIZED = 'RoIdCardTD3.GivenNames';
RoIdCardTD3.ID_FIELD_NAME = 'ID';
RoIdCardTD3.ID_FIELD_NAME_NORMALIZED = 'RoIdCardTD3.ID';
RoIdCardTD3.ISSUING_AUTHORITY_FIELD_NAME = 'IssuingAuthority';
RoIdCardTD3.ISSUING_AUTHORITY_FIELD_NAME_NORMALIZED = 'RoIdCardTD3.IssuingAuthority';
RoIdCardTD3.NATIONALITY_FIELD_NAME = 'Nationality';
RoIdCardTD3.NATIONALITY_FIELD_NAME_NORMALIZED = 'RoIdCardTD3.Nationality';
RoIdCardTD3.PERSONAL_NUMBER_FIELD_NAME = 'PersonalNumber';
RoIdCardTD3.PERSONAL_NUMBER_FIELD_NAME_NORMALIZED = 'RoIdCardTD3.PersonalNumber';
RoIdCardTD3.PHOTO_FIELD_NAME = 'Photo';
RoIdCardTD3.PHOTO_FIELD_NAME_NORMALIZED = 'RoIdCardTD3.Photo';
RoIdCardTD3.RAW_MRZ_FIELD_NAME = 'RawMRZ';
RoIdCardTD3.RAW_MRZ_FIELD_NAME_NORMALIZED = 'RoIdCardTD3.RawMRZ';
RoIdCardTD3.SURNAME_FIELD_NAME = 'Surname';
RoIdCardTD3.SURNAME_FIELD_NAME_NORMALIZED = 'RoIdCardTD3.Surname';
RoIdCardTD3.VALID_FROM_DATE_FIELD_NAME = 'ValidFromDate';
RoIdCardTD3.VALID_FROM_DATE_FIELD_NAME_NORMALIZED = 'RoIdCardTD3.ValidFromDate';
/** ItIdCardFront */
export class ItIdCardFront {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return ItIdCardFront.DOCUMENT_TYPE;
    }
    /** Date of Birth */
    get birthDate() {
        return this.document.fields.find((f) => f.type.name === 'BirthDate');
    }
    /** Birthplace */
    get birthplace() {
        return this.document.fields.find((f) => f.type.name === 'Birthplace');
    }
    /** Card Access Number */
    get cardAccessNumber() {
        return this.document.fields.find((f) => f.type.name === 'CardAccessNumber');
    }
    /** Expiry date */
    get expiryDate() {
        return this.document.fields.find((f) => f.type.name === 'ExpiryDate');
    }
    /** Gender */
    get gender() {
        return this.document.fields.find((f) => f.type.name === 'Gender');
    }
    /** Given Names */
    get givenNames() {
        return this.document.fields.find((f) => f.type.name === 'GivenNames');
    }
    /** Height */
    get height() {
        return this.document.fields.find((f) => f.type.name === 'Height');
    }
    /** Identity Document Number */
    get id() {
        return this.document.fields.find((f) => f.type.name === 'ID');
    }
    /** Date of Issue */
    get issueDate() {
        return this.document.fields.find((f) => f.type.name === 'IssueDate');
    }
    /** Nationality */
    get nationality() {
        return this.document.fields.find((f) => f.type.name === 'Nationality');
    }
    /** Photo image */
    get photo() {
        return this.document.fields.find((f) => f.type.name === 'Photo');
    }
    /** Municipality of Issue */
    get placeOfIssue() {
        return this.document.fields.find((f) => f.type.name === 'PlaceOfIssue');
    }
    /** Signature image */
    get signature() {
        return this.document.fields.find((f) => f.type.name === 'Signature');
    }
    /** Surname */
    get surname() {
        return this.document.fields.find((f) => f.type.name === 'Surname');
    }
    /** The child document of type "Metadata". */
    get metadata() {
        const child = this.document.children.find((c) => c.type.name === 'Metadata');
        return new Metadata(child);
    }
}
ItIdCardFront.DOCUMENT_TYPE = 'ItIdCardFront';
ItIdCardFront.BIRTH_DATE_FIELD_NAME = 'BirthDate';
ItIdCardFront.BIRTH_DATE_FIELD_NAME_NORMALIZED = 'ItIdCardFront.BirthDate';
ItIdCardFront.BIRTHPLACE_FIELD_NAME = 'Birthplace';
ItIdCardFront.BIRTHPLACE_FIELD_NAME_NORMALIZED = 'ItIdCardFront.Birthplace';
ItIdCardFront.CARD_ACCESS_NUMBER_FIELD_NAME = 'CardAccessNumber';
ItIdCardFront.CARD_ACCESS_NUMBER_FIELD_NAME_NORMALIZED = 'ItIdCardFront.CardAccessNumber';
ItIdCardFront.EXPIRY_DATE_FIELD_NAME = 'ExpiryDate';
ItIdCardFront.EXPIRY_DATE_FIELD_NAME_NORMALIZED = 'ItIdCardFront.ExpiryDate';
ItIdCardFront.GENDER_FIELD_NAME = 'Gender';
ItIdCardFront.GENDER_FIELD_NAME_NORMALIZED = 'ItIdCardFront.Gender';
ItIdCardFront.GIVEN_NAMES_FIELD_NAME = 'GivenNames';
ItIdCardFront.GIVEN_NAMES_FIELD_NAME_NORMALIZED = 'ItIdCardFront.GivenNames';
ItIdCardFront.HEIGHT_FIELD_NAME = 'Height';
ItIdCardFront.HEIGHT_FIELD_NAME_NORMALIZED = 'ItIdCardFront.Height';
ItIdCardFront.ID_FIELD_NAME = 'ID';
ItIdCardFront.ID_FIELD_NAME_NORMALIZED = 'ItIdCardFront.ID';
ItIdCardFront.ISSUE_DATE_FIELD_NAME = 'IssueDate';
ItIdCardFront.ISSUE_DATE_FIELD_NAME_NORMALIZED = 'ItIdCardFront.IssueDate';
ItIdCardFront.NATIONALITY_FIELD_NAME = 'Nationality';
ItIdCardFront.NATIONALITY_FIELD_NAME_NORMALIZED = 'ItIdCardFront.Nationality';
ItIdCardFront.PHOTO_FIELD_NAME = 'Photo';
ItIdCardFront.PHOTO_FIELD_NAME_NORMALIZED = 'ItIdCardFront.Photo';
ItIdCardFront.PLACE_OF_ISSUE_FIELD_NAME = 'PlaceOfIssue';
ItIdCardFront.PLACE_OF_ISSUE_FIELD_NAME_NORMALIZED = 'ItIdCardFront.PlaceOfIssue';
ItIdCardFront.SIGNATURE_FIELD_NAME = 'Signature';
ItIdCardFront.SIGNATURE_FIELD_NAME_NORMALIZED = 'ItIdCardFront.Signature';
ItIdCardFront.SURNAME_FIELD_NAME = 'Surname';
ItIdCardFront.SURNAME_FIELD_NAME_NORMALIZED = 'ItIdCardFront.Surname';
/** ItIdCardBack */
export class ItIdCardBack {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return ItIdCardBack.DOCUMENT_TYPE;
    }
    /** Address */
    get address() {
        return this.document.fields.find((f) => f.type.name === 'Address');
    }
    /** Barcode data */
    get barcode() {
        return this.document.fields.find((f) => f.type.name === 'Barcode');
    }
    /** Fiscal Code */
    get fiscalCode() {
        return this.document.fields.find((f) => f.type.name === 'FiscalCode');
    }
    /** Issuing authority */
    get issuingAuthority() {
        return this.document.fields.find((f) => f.type.name === 'IssuingAuthority');
    }
    /** Parents information */
    get parents() {
        return this.document.fields.find((f) => f.type.name === 'Parents');
    }
    /** Raw MRZ text value */
    get rawMRZ() {
        return this.document.fields.find((f) => f.type.name === 'RawMRZ');
    }
    /** Remarks */
    get remarks() {
        return this.document.fields.find((f) => f.type.name === 'Remarks');
    }
    /** Validation Photo */
    get validationPhoto() {
        return this.document.fields.find((f) => f.type.name === 'ValidationPhoto');
    }
    /** The child document of type "MRZ". */
    get mrz() {
        const child = this.document.children.find((c) => c.type.name === 'MRZ');
        return new MRZ(child);
    }
    /** The child document of type "Metadata". */
    get metadata() {
        const child = this.document.children.find((c) => c.type.name === 'Metadata');
        return new Metadata(child);
    }
}
ItIdCardBack.DOCUMENT_TYPE = 'ItIdCardBack';
ItIdCardBack.ADDRESS_FIELD_NAME = 'Address';
ItIdCardBack.ADDRESS_FIELD_NAME_NORMALIZED = 'ItIdCardBack.Address';
ItIdCardBack.BARCODE_FIELD_NAME = 'Barcode';
ItIdCardBack.BARCODE_FIELD_NAME_NORMALIZED = 'ItIdCardBack.Barcode';
ItIdCardBack.FISCAL_CODE_FIELD_NAME = 'FiscalCode';
ItIdCardBack.FISCAL_CODE_FIELD_NAME_NORMALIZED = 'ItIdCardBack.FiscalCode';
ItIdCardBack.ISSUING_AUTHORITY_FIELD_NAME = 'IssuingAuthority';
ItIdCardBack.ISSUING_AUTHORITY_FIELD_NAME_NORMALIZED = 'ItIdCardBack.IssuingAuthority';
ItIdCardBack.PARENTS_FIELD_NAME = 'Parents';
ItIdCardBack.PARENTS_FIELD_NAME_NORMALIZED = 'ItIdCardBack.Parents';
ItIdCardBack.RAW_MRZ_FIELD_NAME = 'RawMRZ';
ItIdCardBack.RAW_MRZ_FIELD_NAME_NORMALIZED = 'ItIdCardBack.RawMRZ';
ItIdCardBack.REMARKS_FIELD_NAME = 'Remarks';
ItIdCardBack.REMARKS_FIELD_NAME_NORMALIZED = 'ItIdCardBack.Remarks';
ItIdCardBack.VALIDATION_PHOTO_FIELD_NAME = 'ValidationPhoto';
ItIdCardBack.VALIDATION_PHOTO_FIELD_NAME_NORMALIZED = 'ItIdCardBack.ValidationPhoto';
/** PoIdCardFront */
export class PoIdCardFront {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return PoIdCardFront.DOCUMENT_TYPE;
    }
    /** Date of Birth */
    get birthDate() {
        return this.document.fields.find((f) => f.type.name === 'BirthDate');
    }
    /** Card Access Number */
    get cardAccessNumber() {
        return this.document.fields.find((f) => f.type.name === 'CardAccessNumber');
    }
    /** Expiry date */
    get expiryDate() {
        return this.document.fields.find((f) => f.type.name === 'ExpiryDate');
    }
    /** Family Name */
    get familyName() {
        return this.document.fields.find((f) => f.type.name === 'FamilyName');
    }
    /** Gender */
    get gender() {
        return this.document.fields.find((f) => f.type.name === 'Gender');
    }
    /** Given Names */
    get givenNames() {
        return this.document.fields.find((f) => f.type.name === 'GivenNames');
    }
    /** Identity Document Number */
    get id() {
        return this.document.fields.find((f) => f.type.name === 'ID');
    }
    /** Nationality */
    get nationality() {
        return this.document.fields.find((f) => f.type.name === 'Nationality');
    }
    /** Parents Given Names */
    get parentsGivenNames() {
        return this.document.fields.find((f) => f.type.name === 'ParentsGivenNames');
    }
    /** Photo image */
    get photo() {
        return this.document.fields.find((f) => f.type.name === 'Photo');
    }
    /** Signature image */
    get signature() {
        return this.document.fields.find((f) => f.type.name === 'Signature');
    }
    /** Surname */
    get surname() {
        return this.document.fields.find((f) => f.type.name === 'Surname');
    }
    /** The child document of type "Metadata". */
    get metadata() {
        const child = this.document.children.find((c) => c.type.name === 'Metadata');
        return new Metadata(child);
    }
}
PoIdCardFront.DOCUMENT_TYPE = 'PoIdCardFront';
PoIdCardFront.BIRTH_DATE_FIELD_NAME = 'BirthDate';
PoIdCardFront.BIRTH_DATE_FIELD_NAME_NORMALIZED = 'PoIdCardFront.BirthDate';
PoIdCardFront.CARD_ACCESS_NUMBER_FIELD_NAME = 'CardAccessNumber';
PoIdCardFront.CARD_ACCESS_NUMBER_FIELD_NAME_NORMALIZED = 'PoIdCardFront.CardAccessNumber';
PoIdCardFront.EXPIRY_DATE_FIELD_NAME = 'ExpiryDate';
PoIdCardFront.EXPIRY_DATE_FIELD_NAME_NORMALIZED = 'PoIdCardFront.ExpiryDate';
PoIdCardFront.FAMILY_NAME_FIELD_NAME = 'FamilyName';
PoIdCardFront.FAMILY_NAME_FIELD_NAME_NORMALIZED = 'PoIdCardFront.FamilyName';
PoIdCardFront.GENDER_FIELD_NAME = 'Gender';
PoIdCardFront.GENDER_FIELD_NAME_NORMALIZED = 'PoIdCardFront.Gender';
PoIdCardFront.GIVEN_NAMES_FIELD_NAME = 'GivenNames';
PoIdCardFront.GIVEN_NAMES_FIELD_NAME_NORMALIZED = 'PoIdCardFront.GivenNames';
PoIdCardFront.ID_FIELD_NAME = 'ID';
PoIdCardFront.ID_FIELD_NAME_NORMALIZED = 'PoIdCardFront.ID';
PoIdCardFront.NATIONALITY_FIELD_NAME = 'Nationality';
PoIdCardFront.NATIONALITY_FIELD_NAME_NORMALIZED = 'PoIdCardFront.Nationality';
PoIdCardFront.PARENTS_GIVEN_NAMES_FIELD_NAME = 'ParentsGivenNames';
PoIdCardFront.PARENTS_GIVEN_NAMES_FIELD_NAME_NORMALIZED = 'PoIdCardFront.ParentsGivenNames';
PoIdCardFront.PHOTO_FIELD_NAME = 'Photo';
PoIdCardFront.PHOTO_FIELD_NAME_NORMALIZED = 'PoIdCardFront.Photo';
PoIdCardFront.SIGNATURE_FIELD_NAME = 'Signature';
PoIdCardFront.SIGNATURE_FIELD_NAME_NORMALIZED = 'PoIdCardFront.Signature';
PoIdCardFront.SURNAME_FIELD_NAME = 'Surname';
PoIdCardFront.SURNAME_FIELD_NAME_NORMALIZED = 'PoIdCardFront.Surname';
/** RoIdCardBack */
export class RoIdCardBack {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return RoIdCardBack.DOCUMENT_TYPE;
    }
    /** Address */
    get address() {
        return this.document.fields.find((f) => f.type.name === 'Address');
    }
    /** Date of Issue */
    get issueDate() {
        return this.document.fields.find((f) => f.type.name === 'IssueDate');
    }
    /** Issuing authority */
    get issuingAuthority() {
        return this.document.fields.find((f) => f.type.name === 'IssuingAuthority');
    }
    /** Raw MRZ text value */
    get rawMRZ() {
        return this.document.fields.find((f) => f.type.name === 'RawMRZ');
    }
    /** The child document of type "MRZ". */
    get mrz() {
        const child = this.document.children.find((c) => c.type.name === 'MRZ');
        return new MRZ(child);
    }
    /** The child document of type "Metadata". */
    get metadata() {
        const child = this.document.children.find((c) => c.type.name === 'Metadata');
        return new Metadata(child);
    }
}
RoIdCardBack.DOCUMENT_TYPE = 'RoIdCardBack';
RoIdCardBack.ADDRESS_FIELD_NAME = 'Address';
RoIdCardBack.ADDRESS_FIELD_NAME_NORMALIZED = 'RoIdCardBack.Address';
RoIdCardBack.ISSUE_DATE_FIELD_NAME = 'IssueDate';
RoIdCardBack.ISSUE_DATE_FIELD_NAME_NORMALIZED = 'RoIdCardBack.IssueDate';
RoIdCardBack.ISSUING_AUTHORITY_FIELD_NAME = 'IssuingAuthority';
RoIdCardBack.ISSUING_AUTHORITY_FIELD_NAME_NORMALIZED = 'RoIdCardBack.IssuingAuthority';
RoIdCardBack.RAW_MRZ_FIELD_NAME = 'RawMRZ';
RoIdCardBack.RAW_MRZ_FIELD_NAME_NORMALIZED = 'RoIdCardBack.RawMRZ';
/** RoIdCardFront */
export class RoIdCardFront {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return RoIdCardFront.DOCUMENT_TYPE;
    }
    /** Date of Birth */
    get birthDate() {
        return this.document.fields.find((f) => f.type.name === 'BirthDate');
    }
    /** Card Access Number */
    get cardAccessNumber() {
        return this.document.fields.find((f) => f.type.name === 'CardAccessNumber');
    }
    /** Expiry date */
    get expiryDate() {
        return this.document.fields.find((f) => f.type.name === 'ExpiryDate');
    }
    /** Gender */
    get gender() {
        return this.document.fields.find((f) => f.type.name === 'Gender');
    }
    /** Given Names */
    get givenNames() {
        return this.document.fields.find((f) => f.type.name === 'GivenNames');
    }
    /** Identity Document Number */
    get id() {
        return this.document.fields.find((f) => f.type.name === 'ID');
    }
    /** Nationality */
    get nationality() {
        return this.document.fields.find((f) => f.type.name === 'Nationality');
    }
    /** Personal Number (CNP) */
    get personalNumber() {
        return this.document.fields.find((f) => f.type.name === 'PersonalNumber');
    }
    /** Photo image */
    get photo() {
        return this.document.fields.find((f) => f.type.name === 'Photo');
    }
    /** Signature image */
    get signature() {
        return this.document.fields.find((f) => f.type.name === 'Signature');
    }
    /** Surname */
    get surname() {
        return this.document.fields.find((f) => f.type.name === 'Surname');
    }
    /** The child document of type "Metadata". */
    get metadata() {
        const child = this.document.children.find((c) => c.type.name === 'Metadata');
        return new Metadata(child);
    }
}
RoIdCardFront.DOCUMENT_TYPE = 'RoIdCardFront';
RoIdCardFront.BIRTH_DATE_FIELD_NAME = 'BirthDate';
RoIdCardFront.BIRTH_DATE_FIELD_NAME_NORMALIZED = 'RoIdCardFront.BirthDate';
RoIdCardFront.CARD_ACCESS_NUMBER_FIELD_NAME = 'CardAccessNumber';
RoIdCardFront.CARD_ACCESS_NUMBER_FIELD_NAME_NORMALIZED = 'RoIdCardFront.CardAccessNumber';
RoIdCardFront.EXPIRY_DATE_FIELD_NAME = 'ExpiryDate';
RoIdCardFront.EXPIRY_DATE_FIELD_NAME_NORMALIZED = 'RoIdCardFront.ExpiryDate';
RoIdCardFront.GENDER_FIELD_NAME = 'Gender';
RoIdCardFront.GENDER_FIELD_NAME_NORMALIZED = 'RoIdCardFront.Gender';
RoIdCardFront.GIVEN_NAMES_FIELD_NAME = 'GivenNames';
RoIdCardFront.GIVEN_NAMES_FIELD_NAME_NORMALIZED = 'RoIdCardFront.GivenNames';
RoIdCardFront.ID_FIELD_NAME = 'ID';
RoIdCardFront.ID_FIELD_NAME_NORMALIZED = 'RoIdCardFront.ID';
RoIdCardFront.NATIONALITY_FIELD_NAME = 'Nationality';
RoIdCardFront.NATIONALITY_FIELD_NAME_NORMALIZED = 'RoIdCardFront.Nationality';
RoIdCardFront.PERSONAL_NUMBER_FIELD_NAME = 'PersonalNumber';
RoIdCardFront.PERSONAL_NUMBER_FIELD_NAME_NORMALIZED = 'RoIdCardFront.PersonalNumber';
RoIdCardFront.PHOTO_FIELD_NAME = 'Photo';
RoIdCardFront.PHOTO_FIELD_NAME_NORMALIZED = 'RoIdCardFront.Photo';
RoIdCardFront.SIGNATURE_FIELD_NAME = 'Signature';
RoIdCardFront.SIGNATURE_FIELD_NAME_NORMALIZED = 'RoIdCardFront.Signature';
RoIdCardFront.SURNAME_FIELD_NAME = 'Surname';
RoIdCardFront.SURNAME_FIELD_NAME_NORMALIZED = 'RoIdCardFront.Surname';
/** PoIdCardBack */
export class PoIdCardBack {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return PoIdCardBack.DOCUMENT_TYPE;
    }
    /** Barcode data */
    get barcode() {
        return this.document.fields.find((f) => f.type.name === 'Barcode');
    }
    /** Birthplace */
    get birthplace() {
        return this.document.fields.find((f) => f.type.name === 'Birthplace');
    }
    /** Expiry date */
    get expiryDate() {
        return this.document.fields.find((f) => f.type.name === 'ExpiryDate');
    }
    /** Identity Document Number */
    get id() {
        return this.document.fields.find((f) => f.type.name === 'ID');
    }
    /** Date of Issue */
    get issueDate() {
        return this.document.fields.find((f) => f.type.name === 'IssueDate');
    }
    /** Issuing authority */
    get issuingAuthority() {
        return this.document.fields.find((f) => f.type.name === 'IssuingAuthority');
    }
    /** Nationality */
    get nationality() {
        return this.document.fields.find((f) => f.type.name === 'Nationality');
    }
    /** Parents Given Names */
    get parentsGivenNames() {
        return this.document.fields.find((f) => f.type.name === 'ParentsGivenNames');
    }
    /** Personal Number */
    get personalNumber() {
        return this.document.fields.find((f) => f.type.name === 'PersonalNumber');
    }
    /** Raw MRZ text value */
    get rawMRZ() {
        return this.document.fields.find((f) => f.type.name === 'RawMRZ');
    }
    /** Surname */
    get surname() {
        return this.document.fields.find((f) => f.type.name === 'Surname');
    }
    /** The child document of type "MRZ". */
    get mrz() {
        const child = this.document.children.find((c) => c.type.name === 'MRZ');
        return new MRZ(child);
    }
    /** The child document of type "Metadata". */
    get metadata() {
        const child = this.document.children.find((c) => c.type.name === 'Metadata');
        return new Metadata(child);
    }
}
PoIdCardBack.DOCUMENT_TYPE = 'PoIdCardBack';
PoIdCardBack.BARCODE_FIELD_NAME = 'Barcode';
PoIdCardBack.BARCODE_FIELD_NAME_NORMALIZED = 'PoIdCardBack.Barcode';
PoIdCardBack.BIRTHPLACE_FIELD_NAME = 'Birthplace';
PoIdCardBack.BIRTHPLACE_FIELD_NAME_NORMALIZED = 'PoIdCardBack.Birthplace';
PoIdCardBack.EXPIRY_DATE_FIELD_NAME = 'ExpiryDate';
PoIdCardBack.EXPIRY_DATE_FIELD_NAME_NORMALIZED = 'PoIdCardBack.ExpiryDate';
PoIdCardBack.ID_FIELD_NAME = 'ID';
PoIdCardBack.ID_FIELD_NAME_NORMALIZED = 'PoIdCardBack.ID';
PoIdCardBack.ISSUE_DATE_FIELD_NAME = 'IssueDate';
PoIdCardBack.ISSUE_DATE_FIELD_NAME_NORMALIZED = 'PoIdCardBack.IssueDate';
PoIdCardBack.ISSUING_AUTHORITY_FIELD_NAME = 'IssuingAuthority';
PoIdCardBack.ISSUING_AUTHORITY_FIELD_NAME_NORMALIZED = 'PoIdCardBack.IssuingAuthority';
PoIdCardBack.NATIONALITY_FIELD_NAME = 'Nationality';
PoIdCardBack.NATIONALITY_FIELD_NAME_NORMALIZED = 'PoIdCardBack.Nationality';
PoIdCardBack.PARENTS_GIVEN_NAMES_FIELD_NAME = 'ParentsGivenNames';
PoIdCardBack.PARENTS_GIVEN_NAMES_FIELD_NAME_NORMALIZED = 'PoIdCardBack.ParentsGivenNames';
PoIdCardBack.PERSONAL_NUMBER_FIELD_NAME = 'PersonalNumber';
PoIdCardBack.PERSONAL_NUMBER_FIELD_NAME_NORMALIZED = 'PoIdCardBack.PersonalNumber';
PoIdCardBack.RAW_MRZ_FIELD_NAME = 'RawMRZ';
PoIdCardBack.RAW_MRZ_FIELD_NAME_NORMALIZED = 'PoIdCardBack.RawMRZ';
PoIdCardBack.SURNAME_FIELD_NAME = 'Surname';
PoIdCardBack.SURNAME_FIELD_NAME_NORMALIZED = 'PoIdCardBack.Surname';
/** TrIdCardBack */
export class TrIdCardBack {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return TrIdCardBack.DOCUMENT_TYPE;
    }
    /** Barcode data */
    get barcode() {
        return this.document.fields.find((f) => f.type.name === 'Barcode');
    }
    /** Father's Name */
    get fathersName() {
        return this.document.fields.find((f) => f.type.name === 'FathersName');
    }
    /** Issuing authority */
    get issuingAuthority() {
        return this.document.fields.find((f) => f.type.name === 'IssuingAuthority');
    }
    /** Mother's Name */
    get mothersName() {
        return this.document.fields.find((f) => f.type.name === 'MothersName');
    }
    /** Raw MRZ text value */
    get rawMRZ() {
        return this.document.fields.find((f) => f.type.name === 'RawMRZ');
    }
    /** The child document of type "MRZ". */
    get mrz() {
        const child = this.document.children.find((c) => c.type.name === 'MRZ');
        return new MRZ(child);
    }
    /** The child document of type "Metadata". */
    get metadata() {
        const child = this.document.children.find((c) => c.type.name === 'Metadata');
        return new Metadata(child);
    }
}
TrIdCardBack.DOCUMENT_TYPE = 'TrIdCardBack';
TrIdCardBack.BARCODE_FIELD_NAME = 'Barcode';
TrIdCardBack.BARCODE_FIELD_NAME_NORMALIZED = 'TrIdCardBack.Barcode';
TrIdCardBack.FATHERS_NAME_FIELD_NAME = 'FathersName';
TrIdCardBack.FATHERS_NAME_FIELD_NAME_NORMALIZED = 'TrIdCardBack.FathersName';
TrIdCardBack.ISSUING_AUTHORITY_FIELD_NAME = 'IssuingAuthority';
TrIdCardBack.ISSUING_AUTHORITY_FIELD_NAME_NORMALIZED = 'TrIdCardBack.IssuingAuthority';
TrIdCardBack.MOTHERS_NAME_FIELD_NAME = 'MothersName';
TrIdCardBack.MOTHERS_NAME_FIELD_NAME_NORMALIZED = 'TrIdCardBack.MothersName';
TrIdCardBack.RAW_MRZ_FIELD_NAME = 'RawMRZ';
TrIdCardBack.RAW_MRZ_FIELD_NAME_NORMALIZED = 'TrIdCardBack.RawMRZ';
/** TrIdCardFront */
export class TrIdCardFront {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return TrIdCardFront.DOCUMENT_TYPE;
    }
    /** Date of Birth */
    get birthDate() {
        return this.document.fields.find((f) => f.type.name === 'BirthDate');
    }
    /** Expiry date */
    get expiryDate() {
        return this.document.fields.find((f) => f.type.name === 'ExpiryDate');
    }
    /** Gender */
    get gender() {
        return this.document.fields.find((f) => f.type.name === 'Gender');
    }
    /** Given Names */
    get givenNames() {
        return this.document.fields.find((f) => f.type.name === 'GivenNames');
    }
    /** Identity Document Number */
    get id() {
        return this.document.fields.find((f) => f.type.name === 'ID');
    }
    /** Nationality */
    get nationality() {
        return this.document.fields.find((f) => f.type.name === 'Nationality');
    }
    /** Personal Number */
    get personalNumber() {
        return this.document.fields.find((f) => f.type.name === 'PersonalNumber');
    }
    /** Signature image */
    get signature() {
        return this.document.fields.find((f) => f.type.name === 'Signature');
    }
    /** Surname */
    get surname() {
        return this.document.fields.find((f) => f.type.name === 'Surname');
    }
    /** The child document of type "Metadata". */
    get metadata() {
        const child = this.document.children.find((c) => c.type.name === 'Metadata');
        return new Metadata(child);
    }
}
TrIdCardFront.DOCUMENT_TYPE = 'TrIdCardFront';
TrIdCardFront.BIRTH_DATE_FIELD_NAME = 'BirthDate';
TrIdCardFront.BIRTH_DATE_FIELD_NAME_NORMALIZED = 'TrIdCardFront.BirthDate';
TrIdCardFront.EXPIRY_DATE_FIELD_NAME = 'ExpiryDate';
TrIdCardFront.EXPIRY_DATE_FIELD_NAME_NORMALIZED = 'TrIdCardFront.ExpiryDate';
TrIdCardFront.GENDER_FIELD_NAME = 'Gender';
TrIdCardFront.GENDER_FIELD_NAME_NORMALIZED = 'TrIdCardFront.Gender';
TrIdCardFront.GIVEN_NAMES_FIELD_NAME = 'GivenNames';
TrIdCardFront.GIVEN_NAMES_FIELD_NAME_NORMALIZED = 'TrIdCardFront.GivenNames';
TrIdCardFront.ID_FIELD_NAME = 'ID';
TrIdCardFront.ID_FIELD_NAME_NORMALIZED = 'TrIdCardFront.ID';
TrIdCardFront.NATIONALITY_FIELD_NAME = 'Nationality';
TrIdCardFront.NATIONALITY_FIELD_NAME_NORMALIZED = 'TrIdCardFront.Nationality';
TrIdCardFront.PERSONAL_NUMBER_FIELD_NAME = 'PersonalNumber';
TrIdCardFront.PERSONAL_NUMBER_FIELD_NAME_NORMALIZED = 'TrIdCardFront.PersonalNumber';
TrIdCardFront.SIGNATURE_FIELD_NAME = 'Signature';
TrIdCardFront.SIGNATURE_FIELD_NAME_NORMALIZED = 'TrIdCardFront.Signature';
TrIdCardFront.SURNAME_FIELD_NAME = 'Surname';
TrIdCardFront.SURNAME_FIELD_NAME_NORMALIZED = 'TrIdCardFront.Surname';
//# sourceMappingURL=DocumentsModel.js.map